import React, { useState, useEffect } from 'react'
import './MoreProfileDetails.css'
import { useLocation } from "react-router-dom";
import { Form, Modal, Button } from 'react-bootstrap';
import { addMonths } from 'date-fns';
import { useHistory } from "react-router-dom";
import HoroscopeModal from './HoroscopeModal';
import { maskUsernamefull } from '../Common/commonfunctions';
import * as environment from '../../coreservices/environment'

const MoreProfileDetails = () => {

    const history = useHistory();
    const location = useLocation();

    const [ITEM, setITEM] = useState(location?.state?.state?.ITEM);
    const [LOGGEDUSERDATA, setLOGGEDUSERDATA] = useState(location?.state?.state?.loggedUsersData);
    //     localStorage.setItem('LOGGEDUSERDATA_message', JSON.stringify(location?.state?.state?.LOGGEDUSERDATA))
    //     localStorage.setItem('ITEM_message', JSON.stringify(location?.state?.state?.ITEM))


    // useEffect(() => {
    //     // console.log(JSON.parse(localStorage.getItem('LOGGEDUSERDATA_message')));
    //     // console.log(JSON.parse(localStorage.getItem('ITEM_message')));
    //     if(JSON.parse(localStorage.getItem('LOGGEDUSERDATA_message')) && JSON.parse(localStorage.getItem('ITEM_message'))){
    //         setLOGGEDUSERDATA(JSON.parse(localStorage.getItem('LOGGEDUSERDATA_message')))
    //         setITEM(JSON.parse(localStorage.getItem('ITEM_message')))
    //         // window.location.reload()
    //     }
    // }, [JSON.parse(localStorage.getItem('LOGGEDUSERDATA_message')),JSON.parse(localStorage.getItem('ITEM_message'))])
    // // message code start


    // Store data in localStorage
    if (location?.state?.state?.loggedUsersData) {
        localStorage.setItem('LOGGEDUSERDATA_message', JSON.stringify(location.state.state.loggedUsersData));
    }
    if (location?.state?.state?.ITEM) {
        localStorage.setItem('ITEM_message', JSON.stringify(location.state.state.ITEM));
    }
    let loggedUserData = ''
    let itemData = ''

    useEffect(() => {

        loggedUserData = localStorage.getItem('LOGGEDUSERDATA_message');
        itemData = localStorage.getItem('ITEM_message');

        //    setLOGGEDUSERDATA(JSON.parse(localStorage.getItem('LOGGEDUSERDATA_message')))
        // setITEM(JSON.parse(localStorage.getItem('ITEM_message')))


        if (loggedUserData && itemData) {
            loggedUserData = localStorage.getItem('LOGGEDUSERDATA_message');
            itemData = localStorage.getItem('ITEM_message');
            try {
                const parsedLoggedUserData = JSON.parse(loggedUserData);
                const parsedItemData = JSON.parse(itemData);

                setLOGGEDUSERDATA(parsedLoggedUserData);
                setITEM(parsedItemData);
                // window.location.reload(); // Uncomment if necessary
            } catch (e) {
                console.error("Error parsing JSON from localStorage", e);
            }
        }
        // JSON.parse(localStorage.getItem('LOGGEDUSERDATA_message'))
    }, [loggedUserData, itemData]);

    let packagePaymentStatus = localStorage.getItem('packagePaymentStatus')
    // useEffect(() => {
    // packagePaymentStatus=localStorage.getItem('packagePaymentStatus');
    // }, [packagePaymentStatus]);


    const handleRedirectPackage = () => {
        console.log('====================================');
        const userConfirmed = window.confirm("Please buy package to send message.");
        if (userConfirmed) {
            history.push('/InnerPackage', { state: { userId: LOGGEDUSERDATA?.userId, name: LOGGEDUSERDATA?.firstName, mobile: LOGGEDUSERDATA?.phone, email: LOGGEDUSERDATA?.email, amount: "1", fromPage: "MoreProfileDetails" } });
        }

    }





    const handleRedirectMessage = () => {
        console.log('====================================');
        console.log("LOGGEDUSERDATA", LOGGEDUSERDATA);
        console.log("ITEM", ITEM);
        console.log('====================================');
        history.push()
        history.push('/chatbox', { state: { LOGGEDUSERDATA: LOGGEDUSERDATA, ITEM: ITEM } });
    }


    // message code end




    const [Match_Pref_Data, set_Match_Pref_Data] = useState(location?.state?.state?.match_pref_Data);

    console.log('====================================');
    console.log("location?.state?.state?.ITEM", location?.state?.state?.loggedUsersData);
    console.log("location?.state?.state?.ITEM", location?.state?.state?.ITEM);
    console.log("location?.state?.state?.match_pref_Data", location?.state?.state?.match_pref_Data);
    console.log('====================================');

    const userId_matchers_u = localStorage.getItem('userId_matchers');

    console.log('====================================');
    console.log("userId_matchers_u", userId_matchers_u);
    console.log('====================================');

    const [paymentStatus, setPaymentStatus] = useState(
        {
            "_id": "65d2658cdd55fa6a91c7bce5",
            "userId": 5,
            "packagePaymentStatus": "Paid",
            "satisfactionTestPaymentStatus": "NotPaid",
            "personalityTestPaymentStatus": "NotPaid",
            "fiftyQuestionTestPaymentStatus": "NotPaid",
            "hundredQuestionTestPaymentStatus": "NotPaid",
            "sixteenpersonalityfactorQuestionTestPaymentStatus": "NotPaid",
            "bloodgroupingTestPaymentStatus": "NotPaid",
            "chronicdisordersTestPaymentStatus": "NotPaid",
            "infertilityScreeningTestPaymentStatus": "NotPaid",
            "sexuallytransmittedDiseasesTestPaymentStatus": "NotPaid",
            "thalassemiaTestTestPaymentStatus": "NotPaid",
            "__v": 0,
            "packageMobileAvailable": "3",
            "packageName": "basic",
            "packagePrice": "99.00",
            "packageTYSAvailable": "2",
            "packageValidity": "1"
        }
    );

    useEffect(() => {
        if (LOGGEDUSERDATA?.userId != "") {
            fetchPaymentStatus();
        }
    }, [LOGGEDUSERDATA?.userId]);

    const fetchPaymentStatus = async () => {
        console.log('====================================');
        console.log("LOGGEDUSERDATA?.userId", LOGGEDUSERDATA?.userId);
        console.log('====================================');
        try {
            const response = await fetch(`${environment.apiUrl}/paymentstatus/${LOGGEDUSERDATA?.userId}`);

            if (response.ok) {
                const data = await response.json();
                setPaymentStatus(data);
                packagePaymentStatus = data?.packagePaymentStatus
                // handle_Update_Item(data)
                console.log('====================================');
                console.log("data_pa", data);
                console.log('====================================');

                // console.error('Failed to fetch payment status');
            }
        } catch (error) {
            console.error('Error fetching payment status:', error);
        }
    };

    useEffect(() => {
        if (LOGGEDUSERDATA?.userId != "" && ITEM?.userId != "") {
            handle_Update_Item();
        }
    }, [LOGGEDUSERDATA?.userId, ITEM?.userId]);

    const handle_Update_Item = async (data) => {
        console.log('====================================');
        console.log("?.packagePaymentStatus", paymentStatus?.packagePaymentStatus);
        console.log('====================================');

        const foundObject = Match_Pref_Data?.FinalData.find(item => (
            item.userId_main === LOGGEDUSERDATA?.userId && item.userId_matchers === ITEM?.userId
        ));

        const singleprefdata = {
            userId_main: foundObject?.userId_main,
            userId_matchers: foundObject?.userId_matchers,
            Score: foundObject?.Score,
            per: foundObject?.per,
            match_pref: foundObject?.match_pref,
        }

        console.log("singleprefdata", singleprefdata);

        const partner_match_data = {
            userId: LOGGEDUSERDATA?.userId,
            userId_main: LOGGEDUSERDATA?.userId,
            userId_matchers: ITEM?.userId,
            bttAvailableMobile: paymentStatus?.packagePaymentStatus == "Paid" && paymentStatus?.packageMobileAvailable != "0" ? true : false,
            bttAvailableTYS: paymentStatus?.packagePaymentStatus == "Paid" && paymentStatus?.packageMobileAvailable != "0" ? true : false,
            item_data_partner: location?.state?.state?.ITEM,
            FinalData: singleprefdata
        }

        console.log('====================================');
        console.log("partner_match_data", partner_match_data);
        console.log('====================================');
        try {
            const response = await fetch(`${environment.apiUrl}/partnerpreferencedatamatch/updatePartnerMatchData/${LOGGEDUSERDATA?.userId}/${ITEM?.userId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(partner_match_data),
            });

            if (!response.ok) {
                throw new Error('Failed to update user data');
            }
            fetchDataPartner()
            // Handle success (redirect, show a message, etc.)
            console.log('User data updated successfully');
        } catch (error) {
            console.error('Error updating user data:', error.message);
        }
    };

    const [partnerrData, setpartnerrData] = useState({});

    const fetchDataPartner = async () => {

        const response = await fetch(`${environment.apiUrl}/partnerpreferencedatamatch/findPartnerMatchData/${LOGGEDUSERDATA?.userId}/${ITEM?.userId}`); // Replace with your actual API endpoint

        console.log('====================================');
        console.log("response", response);
        console.log('====================================');
        const data = await response.json();
        console.log('====================================');
        console.log("data_res", data);
        console.log('====================================');
        setpartnerrData(data);

    };

    // const handle_Create_Item = async () => {
    //     const partner_match_data = {
    //         userId: LOGGEDUSERDATA?.userId,
    //         userId_main: LOGGEDUSERDATA?.userId,
    //         userId_matchers: ITEM?.userId,
    //         bttAvailableMobile: true,
    //         bttAvailableTYS: true,
    //         item_data_partner: location?.state?.state?.ITEM
    //     };

    //     try {
    //         const response = await fetch(`${environment.apiUrl}/partnerpreferencedatamatch`, {
    //             method: 'POST',  // Change the method to POST
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //             body: JSON.stringify(partner_match_data),
    //         });

    //         if (!response.ok) {
    //             throw new Error('Failed to create user data');
    //         }

    //         // Handle success (redirect, show a message, etc.)
    //         console.log('User data created successfully');
    //     } catch (error) {
    //         console.error('Error creating user data:', error.message);
    //     }
    // };

    // useEffect(() => {
    //     if (userId_matchers_u != '') {
    //         getUserDetail()
    //     }
    // }, [userId_matchers_u])

    // const getUserDetail = async () => {


    //     try {
    //         const response = await fetch(`${environment.apiUrl}/signupprofiles/getdet/${userId_matchers_u}`); // Replace with your API endpoint
    //         if (!response.ok) {
    //             throw new Error('Network response was not ok.');
    //         }
    //         const fetchedData = await response.json();
    //         console.log("result_matchindData", fetchedData);
    //         //   set_match_final_Data_allprint_object(result);
    //         //   match_final_Data_allprint_array.push(result);
    //         setITEM(fetchedData)

    //     } catch (error) {
    //         console.error(error.message);
    //     }


    // }

    const emailID = localStorage.getItem('email')
    console.log('====================================');
    console.log("emailIDbbbb", emailID);
    console.log('====================================');

    useEffect(() => {
        if (emailID != '') {
            getUserByEmail()
        }
    }, [emailID])

    const getUserByEmail = async () => {

        try {
            const response = await fetch(`${environment.apiUrl}/signupprofiles/email/${emailID}`); // Replace with your API endpoint
            if (!response.ok) {
                throw new Error('Network response was not ok.');
            }
            const fetchedData = await response.json();
            console.log('====================================');
            console.log("fetchedData", fetchedData);
            console.log('====================================');
            setLOGGEDUSERDATA(fetchedData)
            //   localStorage.setItem('userId', fetchedData.userId);
            //   localStorage.setItem('email', fetchedData.email);
            //   localStorage.setItem('role', 'user');

            //   setnuserId(fetchedData.userId)
            //   setloggedUsersData(fetchedData);
            //   calculateAge(fetchedData.birthdate);
            //   setpic1(fetchedData.pic1);
            //   setpic2(fetchedData.pic2);
            //   setprofileimage(fetchedData.profilepic);

        } catch (error) {
            console.error(error.message);
        }

    }

    // const dataToSave = {
    //     ITEM: location?.state?.state?.ITEM,
    //     loggedUsersData: location?.state?.state?.loggedUsersData
    // }

    // const saveDataToLocalStorage = () => {
    //     localStorage.setItem('after_Payment_Data', JSON.stringify(dataToSave));
    // };

    // //   const clearDataFromLocalStorage = () => {
    // //     localStorage.removeItem('myData');
    // //   };

    // const [retrievedData, setRetrievedData] = useState(null);

    // const getDataFromLocalStorage = () => {
    //     const storedData = localStorage.getItem('after_Payment_Data');
    //     if (storedData) {
    //         // Parse the JSON string back into an object
    //         setRetrievedData(JSON.parse(storedData));
    //     }
    // };

    const searchParams = new URLSearchParams(window?.location?.search);
    const req_body_status = searchParams?.get('status');
    const req_body_amount = searchParams?.get('amount');

    // Your logic for handling failure status
    console.log('req_body_status is', req_body_status);
    console.log('req_body_amount is', req_body_amount);

    // useEffect(() => {
    //     if (req_body_status != "" && req_body_status != null) {
    //         if (req_body_status == "success") {
    //             alert('Success')
    //         } else if (req_body_status == "failure") {
    //             alert('Failure')
    //         }
    //         window.location.reload()
    //     }
    // }, [req_body_status])

    // useEffect(() => {
    //     if (req_body_amount != "" && req_body_amount != null) {
    //         if (req_body_amount == "success") {
    //             alert('Success')
    //         } else if (req_body_amount == "failure") {
    //             alert('Failure')
    //         }
    //         window.location.reload()
    //     }
    // }, [req_body_amount])
    useEffect(() => {
        if (req_body_amount != "" && req_body_amount != null && req_body_status != "" && req_body_status != null) {
            if (req_body_amount == "success") {
                // handleUpdate(req_body_amount)
                alert('Success')
            } else if (req_body_amount == "failure") {
                alert('Payment Failure')
            }
            // window.location.reload()
        }
    }, [])

    const handleUpdate = async (amount) => {
        const paymentStatusData = {
            userId: LOGGEDUSERDATA.userId,
            packagePaymentStatus: 'Paid',
            packageName: 'basic',
            packagePrice: amount,
            packageMobileAvailable: '3',
            packageTYSAvailable: '2',
            packageValidity: '1',

            satisfactionTestPaymentStatus: 'NotPaid',
            personalityTestPaymentStatus: 'NotPaid',
            fiftyQuestionTestPaymentStatus: 'NotPaid',
            hundredQuestionTestPaymentStatus: 'NotPaid',
            sixteenpersonalityfactorQuestionTestPaymentStatus: 'NotPaid',
            bloodgroupingTestPaymentStatus: 'NotPaid',
            chronicdisordersTestPaymentStatus: 'NotPaid',
            infertilityScreeningTestPaymentStatus: 'NotPaid',
            sexuallytransmittedDiseasesTestPaymentStatus: 'NotPaid',
            thalassemiaTestTestPaymentStatus: 'NotPaid',
        };

        try {
            const response = await fetch(`${environment.apiUrl}/paymentstatus/${LOGGEDUSERDATA.userId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    // You may need to include other headers like authorization token
                },
                body: JSON.stringify(paymentStatusData),
            });

            if (response.ok) {
                alert('Payment Successful');
                // updateforbtAvailableMobile()
                console.log('Resource updated successfully');
                // Perform any additional actions after a successful update
            } else {
                console.error('Failed to update resource');
            }
        } catch (error) {
            console.error('Error updating resource:', error);
        }
    };

    // // Function to decreaseCount the count
    // const decreaseCount = () => {
    //     setCount(count - 1);
    // };

    const [username, setusername] = useState("");
    const [mobileNo, setmobileNo] = useState("");
    const [AvailableMobilePattern, setAvailableMobilePattern] = useState(false);
    const [email, setemail] = useState("");

    const updateforbtAvailableMobile = async () => {

        try {
            let updatedData = {
                bttclickmobile: true
            }
            const response = await fetch(`${environment.apiUrl}/partnerpreferencedatamatch/updatePartnerMatchData/${LOGGEDUSERDATA?.userId}/${ITEM?.userId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    // You may need to include other headers like authorization token
                },
                body: JSON.stringify(updatedData),
            });

            if (response.ok) {
                alert('User profile updated successfully');
                // setAvailableMobilePattern(false);
                getUserByEmail()
                fetchDataPartner()
                updateCountforbtAvailableMobile()
                // Perform any additional actions after a successful update
            } else {
                console.error('Failed to update user profile');
            }
        } catch (error) {
            console.error('Error updating user profile:', error);
        }







        // try {
        //     let updatedData = {
        //         bttAvailableMobile: true
        //     }
        //     const response = await fetch(`${environment.apiUrl}/signupprofiles/updateforbtAvailableMobile/${LOGGEDUSERDATA.userId}`, {
        //         method: 'PUT',
        //         headers: {
        //             'Content-Type': 'application/json',
        //             // You may need to include other headers like authorization token
        //         },
        //         body: JSON.stringify(updatedData),
        //     });

        //     if (response.ok) {
        //         alert('User profile updated successfully');
        //         // setAvailableMobilePattern(false);
        //         getUserByEmail()

        //         updateCountforbtAvailableMobile()
        //         // Perform any additional actions after a successful update
        //     } else {
        //         console.error('Failed to update user profile');
        //     }
        // } catch (error) {
        //     console.error('Error updating user profile:', error);
        // }
    };

    const updateCountforbtAvailableMobile = async () => {
        try {
            let updatedData = {
                packageMobileAvailable: paymentStatus.packageMobileAvailable - 1
            }
            const response = await fetch(`${environment.apiUrl}/paymentstatus/${LOGGEDUSERDATA.userId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    // You may need to include other headers like authorization token
                },
                body: JSON.stringify(updatedData),
            });

            if (response.ok) {
                alert('Count updated successfully');


                // Perform any additional actions after a successful update
            } else {
                console.error('Failed to update user profile');
            }
        } catch (error) {
            console.error('Error updating user profile:', error);
        }
    };

    // useEffect(() => {
    //     //         const maskedDigitsmob = ITEM?.phone.slice(0, -5).replace(/\d/g, '*');
    //     //         let mob = maskedDigitsmob + ITEM?.phone.slice(5);
    //     //         // setmobileNo(mob)
    //     // return mob

    //     // const maskedDigitsem = ITEM?.email.slice(0, -5).replace('*');
    //     // let em = maskedDigitsem + ITEM?.email.slice(5);
    //     // setemail(em)

    //     // if (/^.+@.+\..+$/.test(ITEM?.email)) {
    //     //     const maskedUsername = '*'.repeat(5) + ITEM?.email.slice(5);
    //     //     let em = maskedUsername;
    //     //     setemail(em)
    //     // }


    //     // console.log('====================================');
    //     // console.log("mobmobmob", mob, em);
    //     // console.log('====================================');
    // }, [])

    // const maskUsername = (username) => {
    //     const startingPart = username.slice(5, 5);
    //     const maskedPart = '*****';
    //     return startingPart + maskedPart;
    // };

    const maskUsername = (username) => {
        const modifiedName = '*' + '*'.repeat(4) + username.substring(5);
        // setName(modifiedName);
        return modifiedName;
    };

    const maskEmail = (email) => {
        if (/^.+@.+\..+$/.test(email)) {
            const maskedUsername = '*'.repeat(5) + email?.slice(5);
            return maskedUsername;
        }
        // Return the original email if it doesn't match the expected pattern
        return email;
    }

    // const maskMobileNumber = (mobileNumber) => {
    //     const maskedDigitsmob = mobileNumber.slice(0, -5).replace(/\d/g, '*');
    //     let mob = maskedDigitsmob + mobileNumber.slice(5);
    //     // setmobileNo(mob)
    //     return mob
    // };

    const maskMobileNumber = (mobileNumber) => {

        const maskedDigitsmob = mobileNumber?.slice(0, 10).replace(/\d/g, '*');
        let mob = maskedDigitsmob + mobileNumber?.slice(10);
        // setmobileNo(mob)
        return mob;
    };

    const [showModal, setShowModal] = useState(false);

    const confirmSubscription = async () => {
        // Display the confirmation modal
        localStorage.setItem('userId_matchers', ITEM?.userId);
        try {
            const response = await fetch(`${environment.apiUrl}/paymentstatus/${LOGGEDUSERDATA?.userId}`);
            const result = await response.json();
            console.log('====================================');
            console.log("dataPay", result);
            console.log('====================================');
            setDataPay(result);

            if (result?.packagePaymentStatus == "NotPaid") {
                setShowModal(true);
            } else if (result?.packagePaymentStatus == "Paid" && result?.packageMobileAvailable != "0") {
                alert("3noavailable")
                updateforbtAvailableMobile()
            }


        } catch (error) {
            console.error('Error fetching data:', error);
        }


    };

    const [dataPay, setDataPay] = useState({});

    const handleSubscription = async () => {
        // Your subscription logic goes here

        try {
            const response = await fetch(`${environment.apiUrl}/paymentstatus/${LOGGEDUSERDATA?.userId}`);
            const result = await response.json();
            console.log('====================================');
            console.log("dataPay", result);
            console.log('====================================');
            setDataPay(result);

            if (result?.packagePaymentStatus == "NotPaid") {
                history.push('/InnerPackage', { state: { userId: LOGGEDUSERDATA?.userId, name: LOGGEDUSERDATA?.firstName, mobile: LOGGEDUSERDATA?.phone, email: LOGGEDUSERDATA?.email, amount: "1", fromPage: "MoreProfileDetails" } });

            } else if (result?.packagePaymentStatus == "Paid" && result?.packageMobileAvailable != "0") {
                alert("3noavailable")
            }


        } catch (error) {
            console.error('Error fetching data:', error);
        }





        // history.push('/PayUMoneyform', { state: { name: LOGGEDUSERDATA?.name, mobile: LOGGEDUSERDATA?.phone, email: LOGGEDUSERDATA?.email, amount: "1" } });
        // history.push('/Homepagepackage', { state: { userId: LOGGEDUSERDATA?.userId, name: LOGGEDUSERDATA?.name, mobile: LOGGEDUSERDATA?.phone, email: LOGGEDUSERDATA?.email, amount: "1", fromPage: "MoreProfileDetails" } });
        // history.push('/InnerPackage', { state: { userId: LOGGEDUSERDATA?.userId, name: LOGGEDUSERDATA?.name, mobile: LOGGEDUSERDATA?.phone, email: LOGGEDUSERDATA?.email, amount: "1", fromPage: "MoreProfileDetails" } });

        // alert("Subscribed! You can now view full details.");
        // You can add additional logic here, such as redirecting to a subscription page
        // setmobileNo(ITEM?.phone)

        // Close the modal after subscription
        // setShowModal(false);
    };

    const cancelSubscription = () => {
        // Close the modal if the user cancels
        setShowModal(false);
        alert("Subscription cancelled.");
    };

    const [showModalHoroscope, setShowModalHoroscope] = useState(false);

    const handleOpenModalHoroscope = () => {
        setShowModalHoroscope(true);
    };

    const handleCloseModalHoroscope = () => {
        setShowModalHoroscope(false);
    };

    const [isReportModalOpen, setReportModalOpen] = useState(false);

    const handleReportModalOpen = () => {
        setReportModalOpen(true);
    };

    const handleReportModalClose = () => {
        setReportModalOpen(false);
    };

    const [test_name, settest_name] = useState('')
    const handleReportConfirm = async () => {
        // Handle the confirmation logic here
        // For example, navigate to the reports page or perform an action
        // ...

        let reqData = {
            userId: localStorage.getItem('userId'),
            RequestUserId: ITEM.userId,
            RequestId: "0",
            RequestFor: test_name,
            btStatus: false,
            btRequested: true
        }
        try {
            const response = await fetch(`${environment.apiUrl}/request`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    // Add any additional headers if needed
                },
                body: JSON.stringify(reqData),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            // Handle the response data as needed
            const responseData = await response.json();
            getRequestSingles()
            console.log("responseData test", responseData);
        } catch (error) {
            console.error('Error during POST request:', error);
        }

        handleReportModalClose(); // Close the modal after handling the confirmation
    };

    const [RequestSingles, setRequestSingles] = useState({});

    const [bloodGroupfilteredData, setBloodGroupfilteredData] = useState([]);
    const [satisfactiontestfilteredData, setsatisfactiontestfilteredData] = useState([]);


    const [personalitytestfilteredData, setpersonalitytestfilteredData] = useState([]);
    const [sixteenpersonalityfactorfilteredData, setsixteenpersonalityfactorfilteredData] = useState([]);


    const [fiftyquestionsfilteredData, setfiftyquestionsfilteredData] = useState([]);
    const [hundredquestiontestfilteredData, sethundredquestiontestfilteredData] = useState([]);


    const [ThalassemiaTestfilteredData, setThalassemiaTestfilteredData] = useState([]);
    const [STDTestfilteredData, setSTDTestfilteredData] = useState([]);


    const [InfertilityTestfilteredData, setInfertilityTestfilteredData] = useState([]);
    const [ChronicTestfilteredData, setChronicTestfilteredData] = useState([]);

    const [HoroscopeDetailfilteredData, setHoroscopeDetailfilteredData] = useState([]);


    useEffect(() => {
        if (LOGGEDUSERDATA?.userId != "" && ITEM?.userId != "") {
            getRequestSingles()
        }
    }, [LOGGEDUSERDATA?.userId, ITEM?.userId])


    const getRequestSingles = async () => {
        // request for button text requested

        try {
            // const response = await fetch(`${environment.apiUrl}/request/findrequestssingles/${LOGGEDUSERDATA?.userId}`);
            const response = await fetch(`${environment.apiUrl}/request/findrequests1/${LOGGEDUSERDATA?.userId}/${ITEM?.userId}`);
            const result = await response.json();
            console.log('====================================');
            console.log("dataPay", result);
            console.log('====================================');
            setRequestSingles(result);

            const BloodGroupfilteredData = result.filter(item => item.btRequested === true && item.RequestFor === 'BloodGroupTest');
            const SatisfactiontestfilteredData = result.filter(item => item.btRequested === true && item.RequestFor === 'satisfactiontest');

            const PersonalitytestfilteredData = result.filter(item => item.btRequested === true && item.RequestFor === 'personalitytest');
            setpersonalitytestfilteredData(PersonalitytestfilteredData)
            const SixteenpersonalityfactorfilteredData = result.filter(item => item.btRequested === true && item.RequestFor === 'sixteenpersonalityfactor');
            setsixteenpersonalityfactorfilteredData(SixteenpersonalityfactorfilteredData)
            const fiftyquestions_filteredData = result.filter(item => item.btRequested === true && item.RequestFor === 'fiftyquestions');
            setfiftyquestionsfilteredData(fiftyquestions_filteredData)
            const hundredquestiontest_filteredData = result.filter(item => item.btRequested === true && item.RequestFor === 'hundredquestiontest');
            sethundredquestiontestfilteredData(hundredquestiontest_filteredData)
            const ThalassemiaTest_filteredData = result.filter(item => item.btRequested === true && item.RequestFor === 'ThalassemiaTest');
            setThalassemiaTestfilteredData(ThalassemiaTest_filteredData)
            const STDTest_filteredData = result.filter(item => item.btRequested === true && item.RequestFor === 'STDTest');
            setSTDTestfilteredData(STDTest_filteredData)
            const InfertilityTest_filteredData = result.filter(item => item.btRequested === true && item.RequestFor === 'InfertilityTest');
            setInfertilityTestfilteredData(InfertilityTest_filteredData)
            const ChronicTest_filteredData = result.filter(item => item.btRequested === true && item.RequestFor === 'ChronicTest');
            setChronicTestfilteredData(ChronicTest_filteredData)
            const HoroscopeDetail_filteredData = result.filter(item => item.btRequested === true && item.RequestFor === 'HoroscopeDetail');
            setHoroscopeDetailfilteredData(HoroscopeDetail_filteredData)

            setBloodGroupfilteredData(BloodGroupfilteredData)
            setsatisfactiontestfilteredData(SatisfactiontestfilteredData)
            console.log("BloodGroupfilteredData", BloodGroupfilteredData);
            console.log("SatisfactiontestfilteredData", SatisfactiontestfilteredData);
            console.log("PersonalitytestfilteredData", PersonalitytestfilteredData);
            console.log("SixteenpersonalityfactorfilteredData", SixteenpersonalityfactorfilteredData);
            console.log("fiftyquestions_filteredData", fiftyquestions_filteredData);
            console.log("hundredquestiontest_filteredData", hundredquestiontest_filteredData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }


    const handlesendRequest = async (item, testname) => {
        settest_name(testname)
        console.log('====================================');
        if (packagePaymentStatus == 'NotPaid') {
            const userConfirmed = window.confirm("Please buy package to send request.");
            if (userConfirmed) {
                history.push('/InnerPackage', { state: { userId: LOGGEDUSERDATA?.userId, name: LOGGEDUSERDATA?.firstName, mobile: LOGGEDUSERDATA?.phone, email: LOGGEDUSERDATA?.email, amount: "1", fromPage: "MoreProfileDetails" } });
            }

        } else if (packagePaymentStatus == 'Paid') {
            setReportModalOpen(true);
            // console.log("handlesendRequest", item);
            // console.log("testname", testname);

            // let reqData = {
            //     userId: localStorage.getItem('userId'),
            //     RequestUserId: ITEM.userId,
            //     RequestId: "0",
            //     RequestFor: testname,
            //     btStatus: false,
            //     btRequested: true
            // }
            // try {
            //     const response = await fetch(`${environment.apiUrl}/request`, {
            //         method: 'POST',
            //         headers: {
            //             'Content-Type': 'application/json',
            //             // Add any additional headers if needed
            //         },
            //         body: JSON.stringify(reqData),
            //     });

            //     if (!response.ok) {
            //         throw new Error('Network response was not ok');
            //     }

            //     // Handle the response data as needed
            //     const responseData = await response.json();
            //     getRequestSingles()
            //     console.log("responseData test", responseData);
            // } catch (error) {
            //     console.error('Error during POST request:', error);
            // }
        }
    }





    // test qa functionality code

    useEffect(() => {
        createtestdataavailableqa()
    }, [])

    const createtestdataavailableqa = async () => {
        const testqaDataSA = {
            userId: LOGGEDUSERDATA?.userId,
            testuserId: ITEM?.userId,
            path: '',
            btAvailableTestImg: false,
            btAvailablesatisfactionTest: false,
            btAvailablepersonalityTest: false,
            btAvailablefiftyQuestionTest: false,
            btAvailablehundredQuestionTest: false,
            btAvailablesixteenpersonalityfactorQuestionTest: false,
        };
        console.log("testqaDataSA", testqaDataSA);
        try {
            const response = await fetch(`${environment.apiUrl}/testdataavailableqa`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    // Add any additional headers if needed
                },
                body: JSON.stringify(testqaDataSA),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            // Handle the response data as needed
            const responseData = await response.json();
            // fetchRequestData()
            console.log("responseData test", responseData);
            if (LOGGEDUSERDATA?.userId != '' && ITEM?.userId != '') {
                // gettestdataavailableqa("", {})
                const response = await fetch(`${environment.apiUrl}/testdataavailableqa/gettdaqa/${LOGGEDUSERDATA?.userId}/${ITEM?.userId}`);
                const result = await response.json();
                console.log('====================================');
                console.log("datatest", result);
                console.log('====================================');
                setTestQaData(result);
            }
        } catch (error) {
            console.error('Error during POST request:', error);
        }
    }

    const [TestQaData, setTestQaData] = useState({})

    const [isTesthunfif, setisTesthunfif] = useState(false)

    const gettestdataavailableqa = async (test, result_path) => {
        const response = await fetch(`${environment.apiUrl}/testdataavailableqa/gettdaqa/${LOGGEDUSERDATA?.userId}/${ITEM?.userId}`);
        const result = await response.json();
        console.log('====================================');
        console.log("datatest", result);
        console.log('====================================');
        setTestQaData(result);

        if (test == 'satisfactiontest' && result?.btAvailablesatisfactionTest == true ||
            test == 'personalitytest' && result?.btAvailablepersonalityTest == true
            // ||
            // test == 'sixteenpersonalityfactor' && result?.btAvailablesixteenpersonalityfactorQuestionTest == true ||
            // test == 'fiftyquestions' && result?.btAvailablefiftyQuestionTest == true ||
            // test == 'hundredquestiontest' && result?.btAvailablehundredQuestionTest == true
        ) {
            console.log("resultin model", result);
            settestData(result_path);
            setisTest(true)
            setisTestModalOpen(true);
        }

        if (
            // test == 'satisfactiontest' && result?.btAvailablesatisfactionTest == true ||
            // test == 'personalitytest' && result?.btAvailablepersonalityTest == true ||
            // test == 'sixteenpersonalityfactor' && result?.btAvailablesixteenpersonalityfactorQuestionTest == true ||
            test == 'fiftyquestions' && result?.btAvailablefiftyQuestionTest == true ||
            test == 'hundredquestiontest' && result?.btAvailablehundredQuestionTest == true
        ) {
            console.log("resultin model", result);
            settestData(result_path);
            setisTesthunfif(true)
            setisTestModalOpen2(true);
        }

        // if (paymentStatus?.packageTYSAvailable != '0') {
        //     if (test == 'satisfactiontest' && result?.btAvailablesatisfactionTest == false ||
        //         test == 'personalitytest' && result?.btAvailablepersonalityTest == false ||
        //         test == 'sixteenpersonalityfactor' && result?.btAvailablesixteenpersonalityfactorQuestionTest == false ||
        //         test == 'fiftyquestions' && result?.btAvailablefiftyQuestionTest == false ||
        //         test == 'hundredquestiontest' && result?.btAvailablehundredQuestionTest == false
        //     ) {
        //         alert('countqa')
        //         updateCountforbtAvailableTYS()
        //     }
        // }
        //  if(paymentStatus?.packageTYSAvailable=='0') {
        //     alert('Test not available in your package. Please upgrade your package.')
        // }

        // if( test == 'satisfactiontest' && result?.btAvailablesatisfactionTest == false && Object.keys(result_path).length!=0||
        //     test == 'personalitytest' && result?.btAvailablepersonalityTest == false&& Object.keys(result_path).length!=0 ||
        //     test == 'sixteenpersonalityfactor' && result?.btAvailablesixteenpersonalityfactorQuestionTest == false && Object.keys(result_path).length!=0||
        //     test == 'fiftyquestions' && result?.btAvailablefiftyQuestionTest == false && Object.keys(result_path).length!=0||
        //     test == 'hundredquestiontest' && result?.btAvailablehundredQuestionTest == false&& Object.keys(result_path).length!=0
        // ){
        //     updateCountforbtAvailableTYS()
        // }
    }


    const [isTest, setisTest] = useState(false)



    const [isTestModalOpen, setisTestModalOpen] = useState(false);

    const [isTestModalOpen2, setisTestModalOpen2] = useState(false);

    const [testData, settestData] = useState({})
    const handleisTestModalClose = () => {
        setisTestModalOpen(false);
    };

    const handleisTestModalClose2 = () => {
        setisTestModalOpen2(false);
    };

    const handleViewTest = async (test) => {

        try {
            let testaddress = ''
            if (test == "satisfactiontest") {
                testaddress = 'satisfactiontest'
            }
            if (test == "personalitytest") {
                testaddress = 'personalitytest'
            }
            if (test == "sixteenpersonalityfactor") {
                testaddress = 'sixteenpersonalityfactor'
            }
            if (test == "fiftyquestions") {
                testaddress = 'fiftyquestion'
            }
            if (test == "hundredquestiontest") {
                testaddress = 'hundredquestiontest'
            }
            // if (test == "BloodGroupTest") {
            //     testaddress = 'bloodgroupingtest'
            // }

            // if (test == "satisfactiontest") {hundredquestiontest fiftyquestion
            const response = await fetch(`${environment.apiUrl}/${testaddress}/${ITEM?.userId}`);
            const result = await response.json();
            console.log('====================================');
            console.log("datatest", result);
            console.log('====================================');

            if (result?.error == 'Not Found') {
                alert('No test data found.')
            } else {


                // here
                console.log("result-testing", result);
                console.log("result-testing", Object.keys(result).length);
                console.log(paymentStatus);
                if (paymentStatus?.packageTYSAvailable != '0') {
                    // if (Object.keys(result).length != 0) {
                    if (result) {
                        const response = await fetch(`${environment.apiUrl}/testdataavailableqa/gettdaqa/${LOGGEDUSERDATA?.userId}/${ITEM?.userId}`);
                        const resulting = await response.json();
                        // if (paymentStatus?.packageTYSAvailable != '0') {
                        if (test == 'satisfactiontest' && resulting?.btAvailablesatisfactionTest == false ||
                            test == 'personalitytest' && resulting?.btAvailablepersonalityTest == false ||
                            test == 'sixteenpersonalityfactor' && resulting?.btAvailablesixteenpersonalityfactorQuestionTest == false ||
                            test == 'fiftyquestions' && resulting?.btAvailablefiftyQuestionTest == false ||
                            test == 'hundredquestiontest' && resulting?.btAvailablehundredQuestionTest == false
                        ) {
                            alert('countqa')
                            updateCountforbtAvailableTYS()
                        }
                        // }

                        gettestdataavailableqa(test, result)

                        let testqaDataSA = {}
                        if (test == "satisfactiontest") {
                            testqaDataSA = {
                                userId: LOGGEDUSERDATA?.userId,
                                testuserId: ITEM?.userId,
                                btAvailablesatisfactionTest: true,
                            };
                        } else if (test == "personalitytest") {
                            testqaDataSA = {
                                userId: LOGGEDUSERDATA?.userId,
                                testuserId: ITEM?.userId,
                                btAvailablepersonalityTest: true,
                            };
                        } else if (test == "sixteenpersonalityfactor") {
                            testqaDataSA = {
                                userId: LOGGEDUSERDATA?.userId,
                                testuserId: ITEM?.userId,
                                btAvailablesixteenpersonalityfactorQuestionTest: true,
                            };
                        } else if (test == "fiftyquestions") {
                            testqaDataSA = {
                                userId: LOGGEDUSERDATA?.userId,
                                testuserId: ITEM?.userId,
                                btAvailablefiftyQuestionTest: true,
                            };
                        } else if (test == "hundredquestiontest") {
                            testqaDataSA = {
                                userId: LOGGEDUSERDATA?.userId,
                                testuserId: ITEM?.userId,
                                btAvailablehundredQuestionTest: true,
                            };
                        }


                        console.log("testqaDataSA", testqaDataSA);
                        try {
                            const response = await fetch(`${environment.apiUrl}/testdataavailableqa/tdaqa`, {
                                method: 'PUT',
                                headers: {
                                    'Content-Type': 'application/json',
                                    // Add any additional headers if needed
                                },
                                body: JSON.stringify(testqaDataSA),
                            });

                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }

                            // Handle the response data as needed
                            const responseData = await response.json();
                            // fetchRequestData()
                            console.log("responseData test", responseData);

                            // updateCountforbtAvailableTYS()

                            // if (LOGGEDUSERDATA?.userId != '' && ITEM?.userId != '') {
                            //     gettestdataavailableqa(test,result)
                            // }
                        } catch (error) {
                            console.error('Error during PUT request:', error);
                        }
                    }
                }
                // if(paymentStatus?.packageTYSAvailable=='0'){
                //     alert('packageTYSAvailable=0')
                // }
                // if (Object.keys(result).length != 0) {
                if (result) {
                    gettestdataavailableqa(test, result)
                }

                // if (test == 'satisfactiontest' && TestQaData?.btAvailablesatisfactionTest == true ||
                //     test == 'personalitytest' && TestQaData?.btAvailablepersonalityTest == true ||
                //     test == 'sixteenpersonalityfactor' && TestQaData?.btAvailablesixteenpersonalityfactorQuestionTest == true ||
                //     test == 'fiftyquestions' && TestQaData?.btAvailablefiftyQuestionTest == true ||
                //     test == 'hundredquestiontest' && TestQaData?.btAvailablehundredQuestionTest == true
                // ) {
                //     console.log("resultin model", result);
                //     settestData(result);
                //     setisTest(true)
                //     setisTestModalOpen(true);
                // } else {
                //     alert('Test not available in your package. Please upgrade your package.')
                // }
                // end   
            }

            // }
            // if (test == "personalitytest") {
            //     const response = await fetch(`${environment.apiUrl}/personalitytest/${ITEM?.userId}`);
            //     const result = await response.json();
            //     console.log('====================================');
            //     console.log("datatest", result);
            //     console.log('====================================');
            //     settestData(result);
            //     setisTest(true)
            //     setisTestModalOpen(true);
            // }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }





    // test image functionality code

    useEffect(() => {
        createtestdataavailableimg()
    }, [])

    const createtestdataavailableimg = async () => {
        const testimgDataBG = {
            userId: LOGGEDUSERDATA?.userId,
            testuserId: ITEM?.userId,
            path: '',
            btAvailableTestImg: false,
            btAvailablebloodgroupingTest: false,
            btAvailablechronicdisordersTest: false,
            btAvailableinfertilityScreeningTest: false,
            btAvailablesexuallytransmittedDiseasesTest: false,
            btAvailablethalassemiaTestTest: false,
            btAvailableHoroscopeTest: false
        };
        console.log("testimgDataBG", testimgDataBG);
        try {
            const response = await fetch(`${environment.apiUrl}/testdataavailableimg`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    // Add any additional headers if needed
                },
                body: JSON.stringify(testimgDataBG),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            // Handle the response data as needed
            const responseData = await response.json();
            // fetchRequestData()
            console.log("responseData test", responseData);
            if (LOGGEDUSERDATA?.userId != '' && ITEM?.userId != '') {
                // gettestdataavailableimg("", {})
                const response = await fetch(`${environment.apiUrl}/testdataavailableimg/gettdaimg/${LOGGEDUSERDATA?.userId}/${ITEM?.userId}`);
                const result = await response.json();
                console.log('====================================');
                console.log("datatest", result);
                console.log('====================================');
                setTestImgData(result);
            }
        } catch (error) {
            console.error('Error during POST request:', error);
        }
    }

    const [TestImgData, setTestImgData] = useState({})
    const gettestdataavailableimg = async (test, result_path) => {
        const response = await fetch(`${environment.apiUrl}/testdataavailableimg/gettdaimg/${LOGGEDUSERDATA?.userId}/${ITEM?.userId}`);
        const result = await response.json();
        console.log('====================================');
        console.log("datatest", result);
        console.log('====================================');
        setTestImgData(result);

        if (test == 'BloodGroupTest' && result?.btAvailablebloodgroupingTest == true ||
            test == 'ThalassemiaTest' && result?.btAvailablethalassemiaTestTest == true ||
            test == 'ChronicTest' && result?.btAvailablechronicdisordersTest == true ||
            test == 'STDTest' && result?.btAvailablesexuallytransmittedDiseasesTest == true ||
            test == 'InfertilityTest' && result?.btAvailableinfertilityScreeningTest == true ||
            test == 'HoroscopeDetail' && result?.btAvailableHoroscopeTest == true
        ) {
            console.log("resultin model", result_path);
            settestDataa(result_path);
            setisTesta(true)
            setisTestModalOpena(true);
        }

        if (paymentStatus?.packageTYSAvailable != '0') {
            if (test == 'BloodGroupTest' && result?.btAvailablebloodgroupingTest == false ||
                test == 'ThalassemiaTest' && result?.btAvailablethalassemiaTestTest == false ||
                test == 'ChronicTest' && result?.btAvailablechronicdisordersTest == false ||
                test == 'STDTest' && result?.btAvailablesexuallytransmittedDiseasesTest == false ||
                test == 'InfertilityTest' && result?.btAvailableinfertilityScreeningTest == false ||
                test == 'HoroscopeDetail' && result?.btAvailableHoroscopeTest == false
            ) {
                alert("countimg")
                updateCountforbtAvailableTYS()
            }
        }


        //  if(paymentStatus?.packageTYSAvailable=='0') {
        //     alert('Test not available in your package. Please upgrade your package.')
        // }
        // if(test == 'BloodGroupTest'&& result?.btAvailablebloodgroupingTest == false && result_path?.path!=''||
        //     test == 'ThalassemiaTest' && result?.btAvailablethalassemiaTestTest == false&& result_path?.path!='' ||
        //     test == 'ChronicTest' && result?.btAvailablechronicdisordersTest == false && result_path?.path!=''||
        //     test == 'STDTest' && result?.btAvailablesexuallytransmittedDiseasesTest == false && result_path?.path!=''||
        //     test == 'InfertilityTest' && result?.btAvailableinfertilityScreeningTest == false && result_path?.path!=''||
        //     test == 'HoroscopeDetail' && result?.btAvailableHoroscopeTest == false&& result_path?.path!=''
        // ){
        //     updateCountforbtAvailableTYS()
        // }


    }

    const [isTesta, setisTesta] = useState(false)


    const [isTestModalOpena, setisTestModalOpena] = useState(false);
    const [testDataa, settestDataa] = useState({})
    const handleisTestModalClosea = () => {
        setisTestModalOpena(false);
    };
    const handleViewTesta = async (test) => {


        try {
            let testaddress = ''

            if (test == "BloodGroupTest") {
                testaddress = 'bloodgroupingtest'
            }
            if (test == "ThalassemiaTest") {
                testaddress = 'thalassemiatest'
            }
            if (test == "STDTest") {
                testaddress = 'sexuallytransmitteddisease'
            }
            if (test == "InfertilityTest") {
                testaddress = 'infertilityscreening'
            }
            if (test == "ChronicTest") {
                testaddress = 'chronicdisorder'
            }
            if (test == "HoroscopeDetail") {
                testaddress = 'horoscopedetail'
            }


            // if (test == "satisfactiontest") {hundredquestiontest fiftyquestion
            const response = await fetch(`${environment.apiUrl}/${testaddress}/${ITEM?.userId}`);
            const result = await response.json();
            console.log('====================================');
            console.log("datatest", result);
            console.log('====================================');

            if (result?.error == 'Not Found') {
                alert('No test data found.')
            } else {
                console.log("result-testing", result);
                console.log(paymentStatus);
                if (paymentStatus?.packageTYSAvailable != '0') {
                    if (result?.path != "") {

                        gettestdataavailableimg(test, result)

                        let testimgDataBG = {}
                        if (test == "BloodGroupTest") {
                            testimgDataBG = {
                                userId: LOGGEDUSERDATA?.userId,
                                testuserId: ITEM?.userId,
                                btAvailablebloodgroupingTest: true,
                            };
                        } else if (test == "ChronicTest") {
                            testimgDataBG = {
                                userId: LOGGEDUSERDATA?.userId,
                                testuserId: ITEM?.userId,
                                btAvailablechronicdisordersTest: true,
                            };
                        } else if (test == "InfertilityTest") {
                            testimgDataBG = {
                                userId: LOGGEDUSERDATA?.userId,
                                testuserId: ITEM?.userId,
                                btAvailableinfertilityScreeningTest: true,
                            };
                        } else if (test == "STDTest") {
                            testimgDataBG = {
                                userId: LOGGEDUSERDATA?.userId,
                                testuserId: ITEM?.userId,
                                btAvailablesexuallytransmittedDiseasesTest: true,
                            };
                        } else if (test == "ThalassemiaTest") {
                            testimgDataBG = {
                                userId: LOGGEDUSERDATA?.userId,
                                testuserId: ITEM?.userId,
                                btAvailablethalassemiaTestTest: true,
                            };
                        } else if (test == "HoroscopeDetail") {
                            testimgDataBG = {
                                userId: LOGGEDUSERDATA?.userId,
                                testuserId: ITEM?.userId,
                                btAvailableHoroscopeTest: true,
                            };
                        }

                        //  testimgDataBG = {
                        //     userId: LOGGEDUSERDATA?.userId,
                        //     testuserId: ITEM?.userId,
                        //     // path: '',
                        //     // btAvailableTestImg: false,
                        //     btAvailablebloodgroupingTest: test == "BloodGroupTest" ? true : false,
                        //     btAvailablechronicdisordersTest: test == "ChronicTest" ? true : false,
                        //     btAvailableinfertilityScreeningTest: test == "InfertilityTest" ? true : false,
                        //     btAvailablesexuallytransmittedDiseasesTest: test == "STDTest" ? true : false,
                        //     btAvailablethalassemiaTestTest: test == "ThalassemiaTest" ? true : false,
                        //     btAvailableHoroscopeTest: test == "HoroscopeDetail" ? true : false
                        // };
                        console.log("testimgDataBG", testimgDataBG);
                        try {
                            const response = await fetch(`${environment.apiUrl}/testdataavailableimg/tdaimg`, {
                                method: 'PUT',
                                headers: {
                                    'Content-Type': 'application/json',
                                    // Add any additional headers if needed
                                },
                                body: JSON.stringify(testimgDataBG),
                            });

                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }

                            // Handle the response data as needed
                            const responseData = await response.json();
                            // fetchRequestData()
                            console.log("responseData test", responseData);

                            // updateCountforbtAvailableTYS()

                            // if (LOGGEDUSERDATA?.userId != '' && ITEM?.userId != '') {
                            //     gettestdataavailableimg(test,result)
                            // }
                        } catch (error) {
                            console.error('Error during PUT request:', error);
                        }
                    }
                }
                // if(paymentStatus?.packageTYSAvailable=='0'){
                //     alert('packageTYSAvailable=0')
                // }
                if (result?.path != "") {
                    gettestdataavailableimg(test, result)
                }


                // if (test == 'BloodGroupTest' && TestImgData?.btAvailablebloodgroupingTest == true ||
                //     test == 'ThalassemiaTest' && TestImgData?.btAvailablethalassemiaTestTest == true ||
                //     test == 'ChronicTest' && TestImgData?.btAvailablechronicdisordersTest == true ||
                //     test == 'STDTest' && TestImgData?.btAvailablesexuallytransmittedDiseasesTest == true ||
                //     test == 'InfertilityTest' && TestImgData?.btAvailableinfertilityScreeningTest == true ||
                //     test == 'HoroscopeDetail' && TestImgData?.btAvailableHoroscopeTest == true
                // ) {
                //     console.log("resultin model", result);
                //     settestDataa(result);
                //     setisTesta(true)
                //     setisTestModalOpena(true);
                // } else {
                //     alert('Test not available in your package. Please upgrade your package.')
                // }

            }



        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }



    const updateCountforbtAvailableTYS = async () => {
        try {
            let updatedData = {
                packageTYSAvailable: paymentStatus?.packageTYSAvailable - 1
            }
            const response = await fetch(`${environment.apiUrl}/paymentstatus/${LOGGEDUSERDATA.userId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    // You may need to include other headers like authorization token
                },
                body: JSON.stringify(updatedData),
            });

            if (response.ok) {
                // alert('Count updated successfully');
                fetchPaymentStatus()

                // Perform any additional actions after a successful update
            } else {
                console.error('Failed to update user profile');
            }
        } catch (error) {
            console.error('Error updating user profile:', error);
        }
    };

    return (
        <div class="container">
            <div class="main-body">
                <nav aria-label="breadcrumb" class="main-breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                        <li class="breadcrumb-item"><a href="javascript:void(0)">User</a></li>
                        <li class="breadcrumb-item active" aria-current="page">User Profile</li>
                    </ol>
                </nav>
                <div class="row gutters-sm">
                    <div class="col-md-4 mb-3">
                        <div class="card">
                            <div class="card-body">
                                <div class="d-flex flex-column align-items-center text-center">
                                    <img src={ITEM?.profilepic} alt="Admin" class="rounded-circle" width="150" />
                                    <div class="mt-3">
                                        {/* <h4>{maskUsername(ITEM?.name)}</h4>  */}
                                        <h4 class="card-title">{maskUsernamefull(ITEM?.firstName)}<span>{" "}</span>{ITEM?.lastName}</h4>
                                        {/* {ITEM?.name} */}
                                        <p class="text-secondary mb-1">{ITEM?.education}</p>
                                        <p class="text-secondary mb-1">{ITEM?.employment}, {ITEM?.companyname}</p>
                                        <p class="text-muted font-size-sm">{ITEM?.residingcity}, {ITEM?.residingcountry}</p>
                                        <button class="btn btn-primary mr-1">Follow</button>
                                        {packagePaymentStatus == 'NotPaid' ?
                                            <button class="btn btn-outline-primary ml-1" onClick={() => handleRedirectPackage()}>Message</button>
                                            :
                                            <button class="btn btn-outline-primary ml-1" onClick={() => handleRedirectMessage()}>Message</button>
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                        <h4 className='text-left mb-0 mt-3'>Tests </h4>
                        <div class="card mt-0">

                            <ul class="list-group list-group-flush">
                                <li class="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                    <div class="dropdown dr">
                                        <button class="btn btn-secondary dropdown-toggle dr-in" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                            1. Psychological Tests
                                        </button>
                                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                            <li>
                                                <a class="dropdown-item" href="/satisfactiontest">
                                                    Satisfaction Test
                                                </a>
                                                {/* <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "satisfactiontest")}> */}
                                                {satisfactiontestfilteredData[0]?.btRequested == true && satisfactiontestfilteredData[0]?.RequestFor == "satisfactiontest" ? (
                                                    <button type="button" class="btn btn-info">
                                                        {satisfactiontestfilteredData[0]?.btStatus == false ? (
                                                            < span > Requested</span>
                                                        ) :
                                                            < span onClick={() => handleViewTest("satisfactiontest")} > Accepted
                                                                < i class="ri-eye-fill ml-2"></i>
                                                            </span>
                                                        }
                                                    </button>
                                                ) : (
                                                    <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "satisfactiontest")}>
                                                        <span>Request</span>
                                                    </button>
                                                )}
                                                {/* </button> */}
                                            </li>

                                            <li>
                                                <a class="dropdown-item" href="/personalitytest">
                                                    Personality Test
                                                </a>
                                                {/* <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "personalitytest")}> */}
                                                {personalitytestfilteredData[0]?.btRequested == true && personalitytestfilteredData[0]?.RequestFor == "personalitytest" ? (
                                                    <button type="button" class="btn btn-info">
                                                        {personalitytestfilteredData[0]?.btStatus == false ? (
                                                            < span > Requested</span>
                                                        ) :
                                                            < span onClick={() => handleViewTest("personalitytest")} > Accepted
                                                                < i class="ri-eye-fill ml-2"></i>
                                                            </span>
                                                        }
                                                    </button>
                                                ) : (
                                                    <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "personalitytest")}>
                                                        <span>Request</span>
                                                    </button>
                                                )}
                                                {/* </button> */}
                                            </li>
                                            {/* <li>
                                                <a class="dropdown-item" href="/sixteenpersonalityfactor">
                                                    Sixteen Personality Factor
                                                </a>
                                                {sixteenpersonalityfactorfilteredData[0]?.btRequested == true && sixteenpersonalityfactorfilteredData[0]?.RequestFor == "sixteenpersonalityfactor" ? (
                                                    <button type="button" class="btn btn-info">
                                                        {sixteenpersonalityfactorfilteredData[0]?.btStatus == false ? (
                                                            < span > Requested</span>
                                                        ) :
                                                            < span onClick={() => handleViewTest("sixteenpersonalityfactor")} > Accepted
                                                                < i class="ri-eye-fill ml-2"></i>
                                                            </span>
                                                        }
                                                    </button>
                                                ) : (
                                                    <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "sixteenpersonalityfactor")}>
                                                        <span>Request</span>
                                                    </button>
                                                )}
                                            </li> */}
                                            <li>
                                                <a class="dropdown-item" href="/fiftyquestions">
                                                    Fifty Questions Test
                                                </a>
                                                {/* <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "fiftyquestions")}> */}
                                                {fiftyquestionsfilteredData[0]?.btRequested == true && fiftyquestionsfilteredData[0]?.RequestFor == "fiftyquestions" ? (
                                                    <button type="button" class="btn btn-info">
                                                        {fiftyquestionsfilteredData[0]?.btStatus == false ? (
                                                            < span > Requested</span>
                                                        ) :
                                                            < span onClick={() => handleViewTest("fiftyquestions")} > Accepted
                                                                < i class="ri-eye-fill ml-2"></i>
                                                            </span>
                                                        }
                                                    </button>
                                                ) : (
                                                    <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "fiftyquestions")}>
                                                        <span>Request</span>
                                                    </button>
                                                )}
                                                {/* </button> */}
                                            </li>
                                            <li>
                                                <a class="dropdown-item" href="/hundredquestiontest">
                                                    Hundred Question Test
                                                </a>
                                                {/* <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "hundredquestiontest")}> */}
                                                {hundredquestiontestfilteredData[0]?.btRequested == true && hundredquestiontestfilteredData[0]?.RequestFor == "hundredquestiontest" ? (
                                                    <button type="button" class="btn btn-info">
                                                        {hundredquestiontestfilteredData[0]?.btStatus == false ? (
                                                            < span > Requested</span>
                                                        ) :
                                                            < span onClick={() => handleViewTest("hundredquestiontest")} > Accepted
                                                                < i class="ri-eye-fill ml-2"></i>
                                                            </span>
                                                        }
                                                    </button>
                                                ) : (
                                                    <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "hundredquestiontest")}>
                                                        <span>Request</span>
                                                    </button>
                                                )}
                                                {/* </button> */}
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li class="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                    <h6 class="mb-0">
                                        2. Blood grouping Tests
                                    </h6>
                                    {/* <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "BloodGroupTest")}> */}
                                    {bloodGroupfilteredData[0]?.btRequested == true && bloodGroupfilteredData[0]?.RequestFor == "BloodGroupTest" ? (
                                        <button type="button" class="btn btn-info">
                                            {bloodGroupfilteredData[0]?.btStatus == false ? (
                                                < span > Requested</span>
                                            ) :
                                                < span onClick={() => handleViewTesta("BloodGroupTest")} > Accepted
                                                    < i class="ri-eye-fill ml-2"></i>
                                                </span>

                                            }

                                        </button>
                                    ) : (
                                        <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "BloodGroupTest")}>
                                            <span>Request</span>
                                        </button>
                                    )}
                                    {/* </button> */}
                                </li>
                                <li class="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                    <h6 class="mb-0">
                                        3. Thalassemia Tests
                                    </h6>
                                    {/* <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "ThalassemiaTest")}> */}
                                    {ThalassemiaTestfilteredData[0]?.btRequested == true && ThalassemiaTestfilteredData[0]?.RequestFor == "ThalassemiaTest" ? (
                                        <button type="button" class="btn btn-info">
                                            {ThalassemiaTestfilteredData[0]?.btStatus == false ? (
                                                < span > Requested</span>
                                            ) :
                                                < span onClick={() => handleViewTesta("ThalassemiaTest")} > Accepted
                                                    < i class="ri-eye-fill ml-2"></i>
                                                </span>
                                            }
                                        </button>
                                    ) : (
                                        <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "ThalassemiaTest")}>
                                            <span>Request</span>
                                        </button>
                                    )}
                                    {/* </button> */}
                                    {/* <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "ThalassemiaTest")}>Request</button> */}
                                </li>
                                <li class="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                    <h6 class="mb-0" title="Sexually Transmitted Diseases">
                                        4. S. T. D. Test
                                    </h6>
                                    {/* <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "STDTest")}> */}
                                    {STDTestfilteredData[0]?.btRequested == true && STDTestfilteredData[0]?.RequestFor == "STDTest" ? (
                                        <button type="button" class="btn btn-info">
                                            {STDTestfilteredData[0]?.btStatus == false ? (
                                                < span > Requested</span>
                                            ) :
                                                < span onClick={() => handleViewTesta("STDTest")} > Accepted
                                                    < i class="ri-eye-fill ml-2"></i>
                                                </span>
                                            }
                                        </button>
                                    ) : (
                                        <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "STDTest")}>
                                            <span>Request</span>
                                        </button>
                                    )}
                                    {/* </button> */}
                                    {/* <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "STDTest")}>Request</button> */}
                                </li>
                                <li class="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                    <h6 class="mb-0">
                                        5. Infertility Screening
                                    </h6>
                                    {/* <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "InfertilityTest")}> */}
                                    {InfertilityTestfilteredData[0]?.btRequested == true && InfertilityTestfilteredData[0]?.RequestFor == "InfertilityTest" ? (
                                        <button type="button" class="btn btn-info">
                                            {InfertilityTestfilteredData[0]?.btStatus == false ? (
                                                < span > Requested</span>
                                            ) :
                                                < span onClick={() => handleViewTesta("InfertilityTest")} > Accepted
                                                    < i class="ri-eye-fill ml-2"></i>
                                                </span>
                                            }
                                        </button>
                                    ) : (
                                        <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "InfertilityTest")}>
                                            <span>Request</span>
                                        </button>
                                    )}
                                    {/* </button> */}
                                    {/* <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "InfertilityTest")}>Request</button> */}
                                </li>
                                <li class="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                                    <h6 class="mb-0">
                                        6. Chronic disorders
                                    </h6>
                                    {/* <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "ChronicTest")}> */}
                                    {ChronicTestfilteredData[0]?.btRequested == true && ChronicTestfilteredData[0]?.RequestFor == "ChronicTest" ? (
                                        <button type="button" class="btn btn-info">
                                            {ChronicTestfilteredData[0]?.btStatus == false ? (
                                                < span > Requested</span>
                                            ) :
                                                < span onClick={() => handleViewTesta("ChronicTest")} > Accepted
                                                    < i class="ri-eye-fill ml-2"></i>
                                                </span>
                                            }
                                        </button>
                                    ) : (
                                        <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "ChronicTest")}>
                                            <span>Request</span>
                                        </button>
                                    )}
                                    {/* </button> */}
                                    {/* <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "ChronicTest")}>Request</button> */}
                                </li>
                                <li class="list-group-item d-flex justify-content-between align-items-center flex-wrap cursor-pointer" >
                                    <h6 class="mb-0">
                                        7. Horoscope Details
                                    </h6>
                                    {/* <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "HoroscopeDetail")}> */}
                                    {HoroscopeDetailfilteredData[0]?.btRequested == true && HoroscopeDetailfilteredData[0]?.RequestFor == "HoroscopeDetail" ? (
                                        <button type="button" class="btn btn-info">
                                            {HoroscopeDetailfilteredData[0]?.btStatus == false ? (
                                                < span > Requested</span>
                                            ) :
                                                < span onClick={() => handleViewTesta("HoroscopeDetail")} > Accepted
                                                    < i class="ri-eye-fill ml-2"></i>
                                                </span>
                                            }
                                        </button>
                                    ) : (
                                        <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "HoroscopeDetail")}>
                                            <span>Request</span>
                                        </button>
                                    )}
                                    {/* </button> */}
                                    {/* <button type="button" class="btn btn-info" onClick={() => handlesendRequest(ITEM, "HoroscopeDetail")}>Request</button> */}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="card mb-3">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-sm-3">
                                        <h6 class="mb-0">Full Name</h6>
                                    </div>
                                    <div class="col-sm-9 text-secondary">
                                        {/* {maskUsername(ITEM?.name)} */}
                                        {maskUsernamefull(ITEM?.firstName)}<span>{" "}</span>{ITEM?.lastName}
                                        {/* {ITEM?.name} */}
                                    </div>
                                </div>
                                <hr />
                                <div class="row">
                                    <div class="col-sm-3">
                                        <h6 class="mb-0">Mobile</h6>
                                    </div>
                                    <div class="col-sm-9 text-secondary">
                                        <div>
                                            <div>
                                                {partnerrData?.bttAvailableMobile == true && partnerrData?.bttclickmobile == true ? ITEM?.phone : maskMobileNumber(ITEM?.phone)}
                                                {/* {maskMobileNumber(ITEM?.phone)} */}
                                                {/* {ITEM?.phone} */}
                                            </div>
                                            <div>

                                                {partnerrData?.bttclickmobile != true ?
                                                    <button type="button" onClick={confirmSubscription} class="btn btn-info">Available</button>
                                                    :
                                                    null
                                                }
                                                {/* <button type="button" onClick={confirmSubscription} class="btn btn-info">Available</button> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div class="row">
                                    <div class="col-sm-3">
                                        <h6 class="mb-0">Email</h6>
                                    </div>
                                    <div class="col-sm-9 text-secondary">
                                        <div>
                                            <div>
                                                {maskEmail(ITEM?.email)}
                                                {/* {ITEM.email} */}
                                            </div>
                                            {/* <div>
                                                <button type="button" onClick={confirmSubscription} class="btn btn-info">Available</button>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div class="row">
                                    <div class="col-sm-3">
                                        <h6 class="mb-0">Address</h6>
                                    </div>
                                    <div class="col-sm-9 text-secondary">
                                        {ITEM?.birthcity}, {ITEM?.birthstate},   {ITEM?.birthcountry}
                                    </div>
                                </div>
                                <hr />
                            </div>
                        </div>
                        <link href="//maxcdn.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css" rel="stylesheet" id="bootstrap-css" />
                        <script src="//maxcdn.bootstrapcdn.com/bootstrap/4.1.1/js/bootstrap.min.js"></script>
                        <script src="//cdnjs.cloudflare.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script>
                        {/* <!------ Include the above in your HEAD tag ----------> */}
                        <div class="container">
                            <h2>Detailed Profile</h2>
                            <div class="row">
                                <div class="col-md-12 col-lg-12">
                                    <div id="tracking-pre"></div>
                                    <div id="tracking">
                                        {/* <div class="text-center tracking-status-intransit">
                                            <p class="tracking-status text-tight">in transit</p>
                                        </div> */}
                                        <div class="tracking-list">
                                            <div class="tracking-item">
                                                <div class="tracking-icon status-intransit">
                                                    {/* <svg class="svg-inline--fa fa-circle fa-w-16" aria-hidden="true" data-prefix="fas" data-icon="circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg="">
                                                        <path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path>
                                                    </svg> */}
                                                    <svg class="svg-inline--fa fa-circle fa-w-16 w-100 h-100" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 128 128" width="256" height="256"><path fill="#fc785e" d="M98 75v31H30V77.59s1.5-16.84 16.5-20.84h2.57c.12.1.24.19.37.28a23.846 23.846 0 0 0 23.98 3.02 24.108 24.108 0 0 0 5.22-3.07l.29-.23h3.87S98 62.42 98 75Z" class="colorfc785e svgShape"></path><path fill="#e1ebf4" d="M80 37.96a16 16 0 1 1-16-16.03 16.032 16.032 0 0 1 16 16.03Z" class="colore1ebf4 svgShape"></path><path fill="#2d4356" d="M64 17.92a20.035 20.035 0 1 0 20 20.04 20.041 20.041 0 0 0-20-20.04zm0 36.06a16.025 16.025 0 1 1 16-16.02 16.032 16.032 0 0 1-16 16.02zM24.915 17.794a1.984 1.984 0 0 0 1.26-.44 60.756 60.756 0 0 1 4.745-3.49 2.002 2.002 0 0 0-2.207-3.342 64.45 64.45 0 0 0-5.06 3.721 1.997 1.997 0 0 0 1.262 3.551zm-8.944 10.204q.313-.419.635-.833v-.227a6.012 6.012 0 0 1 2.755-5.053 1.985 1.985 0 0 0-3.261-.4 64.52 64.52 0 0 0-3.933 4.903 1.991 1.991 0 0 0-.326 1.61zM4.334 57.718c.202-1.928.5-3.865.883-5.758a2.003 2.003 0 0 0-.82-2.043H2.123a1.995 1.995 0 0 0-.825 1.247 65.405 65.405 0 0 0-.944 6.172l1.984.249zM4.74 73.47a59.44 59.44 0 0 1-.635-5.857 2 2 0 1 0-3.994.233c.122 2.083.35 4.187.678 6.254a2.002 2.002 0 0 0 1.973 1.689 2.059 2.059 0 0 0 .317-.025A2.004 2.004 0 0 0 4.74 73.47zM70.163 4.223l.108.011c1.918.202 3.84.497 5.71.877a2.003 2.003 0 0 0 .795-3.927A64.556 64.556 0 0 0 70.69.25l-.118-.011a2.003 2.003 0 0 0-.408 3.985zm41.23 22.96c.21.271.424.54.63.815h4.908a64.49 64.49 0 0 0-3.283-4.443 1.972 1.972 0 0 0-3.201.148 6.008 6.008 0 0 1 .947 3.235zM54.189 4.67a1.958 1.958 0 0 0 .319-.026 59.844 59.844 0 0 1 5.848-.64A2.003 2.003 0 0 0 60.12.008a63.333 63.333 0 0 0-6.243.682 2.003 2.003 0 0 0 .312 3.982zM99.168 15.3a60.617 60.617 0 0 1 4.593 3.69 2.002 2.002 0 0 0 2.652-2.999 64.637 64.637 0 0 0-4.896-3.935 2.002 2.002 0 0 0-2.348 3.244zM85.397 7.84a59.854 59.854 0 0 1 5.391 2.368 2.03 2.03 0 0 0 2.683-.899 2.005 2.005 0 0 0-.898-2.687 63.914 63.914 0 0 0-5.752-2.526 2.003 2.003 0 0 0-1.424 3.744zM7.07 83.007a2 2 0 1 0-3.795 1.27 64.274 64.274 0 0 0 2.28 5.859 2 2 0 1 0 3.651-1.638 60.058 60.058 0 0 1-2.136-5.491zM38.691 9.299a1.94 1.94 0 0 0 .817-.17 59.86 59.86 0 0 1 5.48-2.144 2.003 2.003 0 0 0-1.27-3.8 63.76 63.76 0 0 0-5.847 2.288 2.005 2.005 0 0 0-1.007 2.648 2.03 2.03 0 0 0 1.827 1.178zm76.657 89.577a1.998 1.998 0 0 0-2.794.44 60.487 60.487 0 0 1-3.694 4.593 2.001 2.001 0 1 0 2.989 2.663 64.389 64.389 0 0 0 3.94-4.898 2.006 2.006 0 0 0-.441-2.798zm-13.58 11.816a60.854 60.854 0 0 1-4.75 3.484 2.002 2.002 0 0 0 2.203 3.344 64.409 64.409 0 0 0 5.064-3.715 2.002 2.002 0 0 0-2.517-3.113zM13.927 97.104a2.001 2.001 0 1 0-3.338 2.209 64.755 64.755 0 0 0 3.713 5.07 2 2 0 1 0 3.105-2.524 60.666 60.666 0 0 1-3.48-4.755zm110.98-44.944a2.002 2.002 0 0 0-1.658 2.294c.309 1.93.524 3.902.643 5.859a2 2 0 0 0 1.994 1.883 2.021 2.021 0 0 0 1.998-2.124 64.357 64.357 0 0 0-.686-6.252 1.989 1.989 0 0 0-2.29-1.66zm.955 16.185a2 2 0 0 0-2.182 1.802l-.014.134a61.174 61.174 0 0 1-.896 5.83 2.002 2.002 0 0 0 1.558 2.363 2.03 2.03 0 0 0 2.36-1.562c.416-2.04.738-4.13.954-6.188l.02-.193a2.004 2.004 0 0 0-1.8-2.186zM122.61 84.38a2 2 0 0 0-2.583 1.155 59.36 59.36 0 0 1-2.374 5.393 2 2 0 1 0 3.577 1.796 63.773 63.773 0 0 0 2.534-5.757 2.005 2.005 0 0 0-1.154-2.587zm-93.839 28.275a60.568 60.568 0 0 1-4.586-3.696 2.002 2.002 0 0 0-2.657 2.995 64.707 64.707 0 0 0 4.892 3.943 2.002 2.002 0 0 0 2.351-3.242zm13.763 7.477c-1.829-.7-3.64-1.498-5.386-2.374a2.002 2.002 0 0 0-1.79 3.583 63.547 63.547 0 0 0 5.748 2.534 2.003 2.003 0 0 0 1.428-3.743zm15.195 3.632a60.75 60.75 0 0 1-5.783-.892 2.003 2.003 0 0 0-.799 3.927c2.028.414 4.101.733 6.069.938.05.008.138.017.188.021q.078.006.156.006a1.986 1.986 0 0 0 1.97-1.823 2.019 2.019 0 0 0-1.801-2.177zm15.692-.4a59.643 59.643 0 0 1-5.85.632 2.004 2.004 0 0 0 .114 4.004c.039 0 .079-.001.118-.003a64.019 64.019 0 0 0 6.243-.675 2.003 2.003 0 0 0-.625-3.958zm15.003-4.465c-1.784.8-3.63 1.518-5.484 2.137a2.004 2.004 0 0 0-1.265 2.534 2.028 2.028 0 0 0 2.53 1.268 63.722 63.722 0 0 0 5.852-2.28 2.003 2.003 0 0 0-1.633-3.659z" class="color2d4356 svgShape"></path><path fill="#2d4356" d="M126 32.01h-18.61v-5.07a1.994 1.994 0 0 0-3.33-1.49L90.67 37.47a1.992 1.992 0 0 0 0 2.98s13.38 12.01 13.39 12.02a2.014 2.014 0 0 0 3.33-1.49v-5.07H126a2.006 2.006 0 0 0 2-2v-9.9a2 2 0 0 0-2-2Zm-2 9.89h-18.61a2.008 2.008 0 0 0-2 2.01v2.58L95 38.96l8.39-7.54v2.59a2.006 2.006 0 0 0 2 2H124Z" class="color2d4356 svgShape"></path><path fill="#ffdb80" d="M124 36.01v5.89h-18.61a2.008 2.008 0 0 0-2 2.01v2.58L95 38.96l8.39-7.54v2.59a2.006 2.006 0 0 0 2 2Z" class="colorffdb80 svgShape"></path><path fill="#2d4356" d="M37.33 37.47 23.94 25.45a1.994 1.994 0 0 0-3.33 1.49v5.07H2a2 2 0 0 0-2 2v9.9a2.006 2.006 0 0 0 2 2h18.61v5.07a2.02 2.02 0 0 0 3.33 1.49l13.39-12.02a1.992 1.992 0 0 0 0-2.98Zm-12.72 9.02v-2.58a2.008 2.008 0 0 0-2-2.01H4v-5.89h18.61a2.006 2.006 0 0 0 2-2v-2.59L33 38.96Z" class="color2d4356 svgShape"></path><path fill="#ffdb80" d="M24.61 46.49v-2.58a2.008 2.008 0 0 0-2-2.01H4v-5.89h18.61a2.006 2.006 0 0 0 2-2v-2.59L33 38.96Z" class="colorffdb80 svgShape"></path><path fill="#a54b3f" d="M32 102.07h64v2H32z" opacity=".5" class="colora54b3f svgShape"></path><path fill="#ffffff" d="M80 37.96c0 .34-.01.67-.03 1a16 16 0 0 0-31.94 0c-.02-.33-.03-.66-.03-1a16 16 0 1 1 32 0Z" opacity=".5" class="colorfff svgShape"></path><path fill="#9fa5aa" d="M80 37.96a16 16 0 1 1-32 0c0-.34.01-.67.03-1a16 16 0 0 0 31.94 0c.02.33.03.66.03 1Z" opacity=".5" class="color9fa5aa svgShape"></path><path fill="#f9dbd7" d="M49.44 57.03a23.599 23.599 0 0 0 5.14 3.02h-3.74A20.026 20.026 0 0 0 32 80.02v-2a20.014 20.014 0 0 1 15.97-19.57l-1.35-1.39zM96 78.02v2a20.026 20.026 0 0 0-18.84-19.97h-3.74a24.108 24.108 0 0 0 5.22-3.07l.81 1.34A20.026 20.026 0 0 1 96 78.02z" opacity=".3" class="colorf9dbd7 svgShape"></path><path fill="#2d4356" d="M100 106.07V78.022a24.068 24.068 0 0 0-18.691-23.44 24.18 24.18 0 0 1-4.154 3.465A20.027 20.027 0 0 1 96 78.023v26.043H32V78.023a20.027 20.027 0 0 1 18.845-19.975 24.18 24.18 0 0 1-4.154-3.465A24.068 24.068 0 0 0 28 78.023v28.046a2.002 2.002 0 0 0 2 2.003h68a2.002 2.002 0 0 0 2-2.003Z" class="color2d4356 svgShape"></path><path fill="#ad9359" d="M103.39 44.49v2L95 38.96l1.11-1 7.28 6.53zM124 39.9v2h-18.61a2.008 2.008 0 0 0-2 2.01v-2a2.008 2.008 0 0 1 2-2.01ZM33 38.96l-8.39 7.53v-2l7.28-6.53 1.11 1zM24.61 41.91v2a2.008 2.008 0 0 0-2-2.01H4v-2h18.61a2.008 2.008 0 0 1 2 2.01Z" opacity=".45" class="colorad9359 svgShape"></path></svg>
                                                    {/* <!-- <i class="fas fa-circle"></i> --> */}
                                                </div>
                                                {/* <div class="tracking-date">Aug 10, 2018<span>05:01 PM</span></div> */}
                                                <div class="tracking-content">About <span>
                                                    {/* <p>{maskUsername(ITEM?.name)}</p> */}
                                                    <div className='d-flex flex-row gap-1'> <span>{maskUsernamefull(ITEM?.firstName)}</span><span>{" "}</span><span>{ITEM?.lastName}</span></div>
                                                    <p className='m-0'>I am what I am. I only focus on the good. Not everyone likes me but then they don't matter. Attitude and class – is what keep me going</p></span></div>
                                            </div>
                                            <div class="tracking-item">
                                                <div class="tracking-icon status-intransit">
                                                    {/* <svg class="svg-inline--fa fa-circle fa-w-16" aria-hidden="true" data-prefix="fas" data-icon="circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg="">
                                                        <path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path>
                                                    </svg> */}
                                                    <svg class="svg-inline--fa fa-circle fa-w-16 w-100 h-100" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 2048 2048" width="256" height="256"><circle cx="1024" cy="1024" r="1024" fill="#00838f" class="color00838f svgShape"></circle><path fill="#fffffe" fill-rule="nonzero" d="M1024 464c62.223 0 119.12 11.754 161.479 44.639 43.32 33.63 70.113 87.623 70.113 170.933 0 80.41-25.158 153.513-65.83 206.698-42.036 54.97-100.612 88.972-165.762 88.972S900.274 941.24 858.237 886.27c-40.673-53.187-65.83-126.288-65.83-206.698 0-83.31 26.794-137.303 70.114-170.933C904.877 475.754 961.777 464 1024 464zM1024 992.652c115.644 0 220.76 47.294 296.952 123.486 76.193 76.192 123.486 181.309 123.486 296.952v74.661c0 26.493-10.822 50.562-28.254 67.995-17.433 17.433-41.504 28.256-67.995 28.256H699.813c-26.494 0-50.562-10.823-67.995-28.256-17.433-17.433-28.256-41.502-28.256-67.995v-74.661c0-115.643 47.294-220.76 123.486-296.952 76.193-76.192 181.31-123.486 296.953-123.486z" class="colorfffffe svgShape"></path></svg>
                                                    {/* <!-- <i class="fas fa-circle"></i> --> */}
                                                </div>
                                                {/* <div class="tracking-date">Jul 20, 2018<span>05:25 PM</span></div> */}
                                                <div class="tracking-content">Contact<span>
                                                    <p className='m-0'>{partnerrData?.bttAvailableMobile == true && partnerrData?.bttclickmobile == true ? ITEM?.phone : maskMobileNumber(ITEM?.phone)}</p>
                                                    <p className='m-0'> {maskEmail(ITEM?.email)}</p>
                                                    {/* <p className='m-0'>{maskMobileNumber(ITEM?.phone)}</p>
                                                    <p className='m-0'> {maskEmail(ITEM.email)}</p> */}
                                                    {partnerrData?.bttclickmobile != true ?
                                                        <p><button type="button" onClick={confirmSubscription} class="btn btn-info">Available</button></p>
                                                        :
                                                        null
                                                    }
                                                </span></div>
                                            </div>
                                            <div class="tracking-item">
                                                <div class="tracking-icon status-intransit">
                                                    {/* <svg id="SvgjsSvg1156" width="256" height="256" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs"><defs id="SvgjsDefs1157"></defs><g id="SvgjsG1158"> */}
                                                    <svg class="svg-inline--fa fa-circle fa-w-16 w-100 h-100" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 128 128" width="256" height="256"><path d="M101.738 38.325a9.31 9.31 0 0 0 5.579.389c.652-.16 1.291-.401 1.957-.5a5.668 5.668 0 0 1 1.606.017c2.473.344 4.205 1.087 6.722.329 2.903-.876 4.785-3.306 6.447-5.69a21.962 21.962 0 0 0 3.533-16.793 11.075 11.075 0 0 0-5.27-7.643 12.505 12.505 0 0 0-10.227-.578c-.03.013-.06.022-.09.034.115-5.087-2.454-7.209-2.788-7.463a2 2 0 0 0-2.418 3.186c.016.012 1.28 1.206 1.198 4.272l-.075-.028a12.508 12.508 0 0 0-10.228.577 11.077 11.077 0 0 0-5.27 7.643 21.963 21.963 0 0 0 3.534 16.793c1.23 1.766 3.09 4.435 5.79 5.455zm22.232 69.678H94.027a4.07 4.07 0 0 0-3.938 4.87 19.382 19.382 0 0 0 37.818 0 4.076 4.076 0 0 0-3.937-4.87zm-11.972-15.997a1.984 1.984 0 0 0-2-1.975 2.02 2.02 0 0 0-1.993 1.856c-.075.07-.193.17-.286.247a4.003 4.003 0 0 0-1.72 3.2 4.445 4.445 0 0 0 1.874 3.336 4.324 4.324 0 0 0-1.875 3.334 1.983 1.983 0 0 0 2 1.973 2.022 2.022 0 0 0 1.993-1.856c.075-.07.195-.17.287-.248a4.007 4.007 0 0 0 1.72-3.203 4.424 4.424 0 0 0-1.874-3.334l.154-.129a4.004 4.004 0 0 0 1.72-3.201zm-9 0a1.984 1.984 0 0 0-2-1.975 2.02 2.02 0 0 0-1.993 1.856c-.075.07-.193.17-.286.247a4.003 4.003 0 0 0-1.72 3.2 4.47 4.47 0 0 0 1.874 3.336c-.051.045-.107.09-.155.131a4.007 4.007 0 0 0-1.72 3.203 1.983 1.983 0 0 0 2 1.973 2.022 2.022 0 0 0 1.994-1.856c.074-.07.194-.17.287-.248a4.007 4.007 0 0 0 1.72-3.203 4.436 4.436 0 0 0-1.875-3.334 4.294 4.294 0 0 0 1.874-3.33zm18 0a1.984 1.984 0 0 0-2-1.975 2.02 2.02 0 0 0-1.993 1.856c-.075.07-.193.17-.286.247a4.003 4.003 0 0 0-1.72 3.2 4.438 4.438 0 0 0 1.874 3.336 4.325 4.325 0 0 0-1.875 3.334 1.983 1.983 0 0 0 2 1.973 2.022 2.022 0 0 0 1.993-1.856c.075-.07.195-.17.287-.248a4.007 4.007 0 0 0 1.72-3.203 4.436 4.436 0 0 0-1.874-3.334 4.293 4.293 0 0 0 1.874-3.33zm-96.998-6H6a6.006 6.006 0 0 0-6 6V122A6.006 6.006 0 0 0 6 128h18a6.006 6.006 0 0 0 6-5.999V92.006a6.006 6.006 0 0 0-6-6zm-9 33.995a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm3-21.996h-6a2 2 0 1 1 0-4h6a2 2 0 1 1 0 4z" fill="#595bd4" class="color000 svgShape"></path><circle cx="63.999" cy="48.013" r="5.999" fill="#595bd4" class="color000 svgShape"></circle><path d="M63.999 28.016a35.994 35.994 0 1 0 36 35.994 36.037 36.037 0 0 0-36-35.994zm0 9.999a9.998 9.998 0 1 1-10 9.998 10.01 10.01 0 0 1 10-9.998zm20 41.993a6.006 6.006 0 0 1-6 5.999h-28a6.006 6.006 0 0 1-6-6V70.01a14.021 14.021 0 0 1 9.17-13.138 14.104 14.104 0 0 0 3.734 3.201A10.013 10.013 0 0 0 48 70.01v9.999a2.002 2.002 0 0 0 2 2h2v-5a2 2 0 0 1 4 0v5h16v-5a2 2 0 0 1 4 0v5h2a2.002 2.002 0 0 0 2-2v-9.999a10.013 10.013 0 0 0-8.904-9.937 14.104 14.104 0 0 0 3.735-3.2 14.021 14.021 0 0 1 9.169 13.137zM12 15a1.944 1.944 0 0 0 .195-.013l1.656-3.595a1.42 1.42 0 0 1 .048-.099 2.534 2.534 0 0 1 2.404-1.29 2.482 2.482 0 0 1 2.235 1.468q.022.052.041.105l1.726 4.843 2.26-3.227a2.169 2.169 0 0 1 .14-.178 2.804 2.804 0 0 1 3.937 0L28.294 15h13.508a12.802 12.802 0 0 0-3.355-10.926A13.238 13.238 0 0 0 21 2.612 13.236 13.236 0 0 0 3.553 4.074 12.802 12.802 0 0 0 .198 15zm13.501 2.895-.731-.878-2.772 3.958a2.212 2.212 0 0 1-.14.176A2.621 2.621 0 0 1 19.89 22a2.878 2.878 0 0 1-.465-.038 2.452 2.452 0 0 1-1.899-1.434l-.04-.104-1.48-4.152-.525 1.14a1.416 1.416 0 0 1-.05.102C14.719 18.855 12.794 19 12 19H1.504a13.208 13.208 0 0 0 2.47 3.365s15.083 14.848 15.098 14.863a2.818 2.818 0 0 0 3.857-.002l15.097-14.86A13.208 13.208 0 0 0 40.495 19H28a3.462 3.462 0 0 1-2.499-1.105z" fill="#595bd4" class="color000 svgShape"></path>
                                                    </svg>
                                                    {/* <!-- <i class="fas fa-circle"></i> --> */}
                                                </div>
                                                {/* <div class="tracking-date">Aug 10, 2018<span>11:19 AM</span></div> */}
                                                <div class="tracking-content">Lifestyle<span>
                                                    <p className='m-0'>Vegeterian</p>
                                                    {/* <p className='m-0'>{ITEM.email}</p> */}
                                                </span></div>
                                            </div>
                                            <div class="tracking-item">
                                                <div class="tracking-icon status-intransit">
                                                    <svg class="svg-inline--fa fa-circle fa-w-16 w-100 h-100" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width="256" height="256"><path fill="#d8a353" d="M225.771 25.913s3.41 12.659 13.229 13.246c0 0-13.107 4.525-13.328 14.202 0 0-2.58-13.572-12.932-14.059 0 0 12.057-1.826 13.031-13.389z" class="colorD7E057 svgShape"></path><path fill="#8526fe" d="M225.671 54.86a1.5 1.5 0 0 1-1.472-1.217c-.024-.124-2.496-12.417-11.529-12.842a1.5 1.5 0 0 1-.155-2.982c.441-.069 10.9-1.817 11.761-12.033a1.5 1.5 0 0 1 2.942-.266c.032.116 3.26 11.626 11.87 12.141a1.5 1.5 0 0 1 .401 2.916c-.121.042-12.124 4.31-12.319 12.819a1.498 1.498 0 0 1-1.499 1.464zm-7.745-15.729c3.88 1.97 6.233 5.747 7.591 8.878 2.027-4.022 5.945-6.788 8.954-8.428-4.137-1.843-6.787-5.653-8.339-8.724-1.794 4.36-5.274 6.869-8.206 8.274z" class="color3A312A svgShape"></path><path fill="#d8a353" d="M204.061 42.893s2.412 8.954 9.357 9.37c0 0-9.271 3.201-9.427 10.045 0 0-1.825-9.6-9.147-9.944 0 0 8.528-1.292 9.217-9.471z" class="colorD7E057 svgShape"></path><path fill="#8526fe" d="M203.99 63.808a1.5 1.5 0 0 1-1.472-1.22c-.016-.082-1.705-8.442-7.744-8.726a1.499 1.499 0 0 1-.155-2.981c.296-.047 7.368-1.243 7.947-8.114a1.5 1.5 0 0 1 2.942-.266c.022.079 2.229 7.919 7.998 8.265a1.5 1.5 0 0 1 .399 2.916c-.08.028-8.287 2.953-8.416 8.662a1.501 1.501 0 0 1-1.499 1.464zm-4.522-11.528c2.109 1.333 3.525 3.395 4.45 5.281 1.377-2.233 3.517-3.873 5.368-4.974-2.288-1.269-3.887-3.351-4.944-5.225-1.174 2.288-3.017 3.877-4.874 4.918z" class="color3A312A svgShape"></path><path fill="#d8a353" d="M204.061 16.236s2.412 8.954 9.357 9.37c0 0-9.271 3.201-9.427 10.045 0 0-1.825-9.6-9.147-9.944 0-.001 8.528-1.292 9.217-9.471z" class="colorD7E057 svgShape"></path><path fill="#8526fe" d="M203.99 37.15a1.5 1.5 0 0 1-1.472-1.22c-.016-.082-1.705-8.442-7.744-8.726a1.502 1.502 0 0 1-.155-2.982c.296-.047 7.368-1.244 7.947-8.114a1.5 1.5 0 0 1 2.943-.266c.038.136 2.25 7.92 7.997 8.263a1.499 1.499 0 0 1 .399 2.915c-.08.028-8.287 2.953-8.416 8.662a1.501 1.501 0 0 1-1.499 1.468zm-4.522-11.527c2.108 1.333 3.525 3.395 4.45 5.281 1.377-2.233 3.517-3.873 5.368-4.974-2.288-1.27-3.887-3.351-4.944-5.225-1.174 2.287-3.017 3.876-4.874 4.918z" class="color3A312A svgShape"></path><path fill="#ad59d4" d="M17 109.032v116.824c0 7.681 6.227 13.908 13.908 13.908h136.684c7.681 0 13.908-6.227 13.908-13.908V44.423c0-7.681-6.227-13.908-13.908-13.908H30.908C23.227 30.514 17 36.742 17 44.423V109.032z" class="color87796F svgShape"></path><path fill="#8526fe" d="M167.592 241.264H30.908c-8.496 0-15.408-6.912-15.408-15.408V109.032a1.5 1.5 0 1 1 3 0v116.824c0 6.842 5.566 12.408 12.408 12.408h136.684c6.842 0 12.408-5.566 12.408-12.408V44.422c0-6.842-5.566-12.408-12.408-12.408H30.908c-6.842 0-12.408 5.566-12.408 12.408v50.569a1.5 1.5 0 1 1-3 0V44.422c0-8.496 6.912-15.408 15.408-15.408h136.684c8.496 0 15.408 6.912 15.408 15.408v181.434c0 8.496-6.912 15.408-15.408 15.408z" class="color3A312A svgShape"></path><path fill="#fae7ca" d="M110.167 227.47h50.564a7.067 7.067 0 0 0 7.068-7.068V51.332a7.068 7.068 0 0 0-7.068-7.068H37.77a7.068 7.068 0 0 0-7.068 7.068v169.07a7.067 7.067 0 0 0 7.068 7.068h72.397z" class="colorFAE6CA svgShape"></path><path fill="#8526fe" d="M160.73 228.97h-50.564a1.5 1.5 0 1 1 0-3h50.564a5.574 5.574 0 0 0 5.568-5.568V51.333a5.574 5.574 0 0 0-5.568-5.568H37.77a5.575 5.575 0 0 0-5.568 5.568v169.07a5.575 5.575 0 0 0 5.568 5.568h59.694a1.5 1.5 0 1 1 0 3H37.77c-4.724 0-8.568-3.844-8.568-8.568V51.333c0-4.724 3.844-8.568 8.568-8.568h122.96c4.724 0 8.568 3.844 8.568 8.568v169.07c0 4.723-3.843 8.567-8.568 8.567z" class="color3A312A svgShape"></path><path fill="#f1bc6c" d="M122.86 26.275c-1.226 0-2.402-.545-3.145-1.52-3.814-5.004-11.544-8.428-20.465-8.428s-16.652 3.424-20.465 8.428c-.743.975-1.919 1.52-3.145 1.52H65.46a4.21 4.21 0 0 0-4.21 4.21v13.813a4.21 4.21 0 0 0 4.21 4.21h67.579a4.21 4.21 0 0 0 4.21-4.21V30.485a4.21 4.21 0 0 0-4.21-4.21H122.86z" class="colorF16C7A svgShape"></path><path fill="#8526fe" d="M133.04 50.009H65.46a5.716 5.716 0 0 1-5.71-5.71V30.485a5.716 5.716 0 0 1 5.71-5.71h10.179c.779 0 1.509-.347 1.953-.929 4.24-5.563 12.539-9.019 21.658-9.019s17.418 3.456 21.658 9.019c.444.582 1.173.929 1.952.929h10.179a5.716 5.716 0 0 1 5.71 5.71v13.813a5.715 5.715 0 0 1-5.709 5.711zM65.46 27.775a2.713 2.713 0 0 0-2.71 2.71v13.813a2.713 2.713 0 0 0 2.71 2.71h67.579a2.713 2.713 0 0 0 2.71-2.71V30.485a2.713 2.713 0 0 0-2.71-2.71H122.86c-1.709 0-3.331-.789-4.338-2.111-3.685-4.835-11.069-7.837-19.272-7.837s-15.588 3.003-19.272 7.837c-1.007 1.322-2.629 2.111-4.338 2.111H65.46zM148.659 176.5H49.841a1.5 1.5 0 1 1 0-3h98.817a1.5 1.5 0 1 1 .001 3zm0 17.5H49.841a1.5 1.5 0 1 1 0-3h98.817a1.5 1.5 0 1 1 .001 3zm0 17.5H49.841a1.5 1.5 0 1 1 0-3h98.817a1.5 1.5 0 1 1 .001 3z" class="color3A312A svgShape"></path><path fill="#f6e3c6" d="M110.779 156.669v-12.456c0-7.589-6.146-13.735-13.744-13.735h-9.086v-7.697H72.68v7.697h-9.082c-7.598 0-13.757 6.146-13.757 13.735v12.456h60.938z" class="colorF6E2C6 svgShape"></path><path fill="#8526fe" d="M110.779 158.169H49.841a1.5 1.5 0 0 1-1.5-1.5v-12.456c0-8.4 6.844-15.234 15.257-15.234h7.582v-6.197a1.5 1.5 0 0 1 1.5-1.5h15.269a1.5 1.5 0 0 1 1.5 1.5v6.197h7.586c8.406 0 15.244 6.834 15.244 15.234v12.456a1.5 1.5 0 0 1-1.5 1.5zm-59.438-3h57.938v-10.956c0-6.746-5.493-12.234-12.244-12.234h-9.086a1.5 1.5 0 0 1-1.5-1.5v-6.197H74.18v6.197a1.5 1.5 0 0 1-1.5 1.5h-9.082c-6.759 0-12.257 5.488-12.257 12.234v10.956z" class="color3A312A svgShape"></path><path fill="#8bd7ce" d="M110.779 144.213v12.456H49.841v-12.456c0-7.589 6.16-13.735 13.757-13.735h10.045l6.662 8.844 6.666-8.844h10.063c7.599.001 13.745 6.147 13.745 13.735z" class="color8BC0D7 svgShape"></path><path fill="#8526fe" d="M110.779 158.169H49.841a1.5 1.5 0 0 1-1.5-1.5v-12.456c0-8.4 6.844-15.234 15.257-15.234h10.045c.471 0 .914.221 1.198.598l5.464 7.254 5.468-7.254a1.5 1.5 0 0 1 1.198-.597h10.063c8.406 0 15.244 6.834 15.244 15.234v12.456a1.498 1.498 0 0 1-1.499 1.499zm-59.438-3h57.938v-10.956c0-6.746-5.493-12.234-12.244-12.234h-9.316l-6.216 8.247a1.498 1.498 0 0 1-2.396-.001l-6.212-8.247h-9.297c-6.759 0-12.257 5.488-12.257 12.234v10.957z" class="color3A312A svgShape"></path><path fill="#8bd7ce" d="M110.779 144.213v12.456H49.841v-12.456c0-7.589 6.16-13.735 13.757-13.735h10.045l6.662 8.844 6.666-8.844h10.063c7.599.001 13.745 6.147 13.745 13.735z" class="color8BC0D7 svgShape"></path><path fill="#8526fe" d="M110.779 158.169H49.841a1.5 1.5 0 0 1-1.5-1.5v-12.456c0-8.4 6.844-15.234 15.257-15.234h10.045c.471 0 .914.221 1.198.598l5.464 7.254 5.468-7.254a1.5 1.5 0 0 1 1.198-.597h10.063c8.406 0 15.244 6.834 15.244 15.234v12.456a1.498 1.498 0 0 1-1.499 1.499zm-59.438-3h57.938v-10.956c0-6.746-5.493-12.234-12.244-12.234h-9.316l-6.216 8.247a1.498 1.498 0 0 1-2.396-.001l-6.212-8.247h-9.297c-6.759 0-12.257 5.488-12.257 12.234v10.957z" class="color3A312A svgShape"></path><path fill="#8526fe" d="M60.978 158.172a1.5 1.5 0 0 1-1.5-1.5v-9.843a1.5 1.5 0 1 1 3 0v9.843a1.5 1.5 0 0 1-1.5 1.5zm38.665 0a1.5 1.5 0 0 1-1.5-1.5v-9.843a1.5 1.5 0 1 1 3 0v9.843a1.5 1.5 0 0 1-1.5 1.5z" class="color3A312A svgShape"></path><path fill="#d8a353" d="m82.656 147.456 1.591-8.125h-7.875l1.59 8.125z" class="colorD7E057 svgShape"></path><path fill="#8526fe" d="M82.656 148.956h-4.694a1.5 1.5 0 0 1-1.472-1.212l-1.59-8.125a1.499 1.499 0 0 1 1.472-1.788h7.875a1.501 1.501 0 0 1 1.472 1.788l-1.591 8.125a1.5 1.5 0 0 1-1.472 1.212zm-3.459-3h2.224l1.003-5.125h-4.23l1.003 5.125z" class="color3A312A svgShape"></path><path fill="#d8a353" d="M84.168 156.668h-7.716l1.511-9.21h4.694z" class="colorD7E057 svgShape"></path><path fill="#8526fe" d="M84.169 158.168h-7.717a1.502 1.502 0 0 1-1.48-1.743l1.511-9.21a1.5 1.5 0 0 1 1.48-1.257h4.694a1.5 1.5 0 0 1 1.48 1.257l1.511 9.21a1.498 1.498 0 0 1-1.479 1.743zm-5.951-3h4.185l-1.019-6.21h-2.146l-1.02 6.21z" class="color3A312A svgShape"></path><path fill="#8bd7ce" d="m65.977 130.468 4.896-3.684 9.433 12.538-4.897 3.684z" class="color8BC0D7 svgShape"></path><path fill="#8526fe" d="M75.412 144.508c-.455 0-.904-.206-1.199-.598l-9.439-12.529a1.5 1.5 0 0 1 .295-2.1l4.895-3.691a1.496 1.496 0 0 1 2.101.295l9.439 12.538a1.5 1.5 0 0 1-.297 2.101l-4.895 3.683a1.49 1.49 0 0 1-.9.301zm-7.34-13.735 7.635 10.135 2.498-1.879-7.634-10.14-2.499 1.884z" class="color3A312A svgShape"></path><path fill="#8bd7ce" d="m94.649 130.479-9.44 12.529-4.903-3.683 9.448-12.538z" class="color8BC0D7 svgShape"></path><path fill="#8526fe" d="M85.209 144.508c-.314 0-.63-.098-.9-.301l-4.904-3.683a1.499 1.499 0 0 1-.297-2.102l9.448-12.538a1.5 1.5 0 0 1 2.101-.295l4.895 3.691a1.5 1.5 0 0 1 .295 2.1l-9.439 12.529a1.496 1.496 0 0 1-1.199.599zm-2.801-5.48 2.505 1.881 7.636-10.136-2.5-1.885-7.641 10.14z" class="color3A312A svgShape"></path><path fill="#f7e4c7" fill-rule="evenodd" d="M62.465 97.427a5.313 5.313 0 0 1-5.314 5.311 5.313 5.313 0 0 1-5.314-5.311 5.313 5.313 0 0 1 5.314-5.311 5.313 5.313 0 0 1 5.314 5.311z" clip-rule="evenodd" class="colorF7E3C7 svgShape"></path><path fill="#8526fe" d="M57.151 104.238c-3.757 0-6.814-3.055-6.814-6.811s3.057-6.811 6.814-6.811 6.813 3.055 6.813 6.811c.001 3.756-3.056 6.811-6.813 6.811zm0-10.622a3.817 3.817 0 0 0-3.814 3.811 3.817 3.817 0 0 0 3.814 3.811 3.817 3.817 0 0 0 3.813-3.811 3.815 3.815 0 0 0-3.813-3.811z" class="color3A312A svgShape"></path><path fill="#f7e4c7" fill-rule="evenodd" d="M108.844 97.427a5.313 5.313 0 0 1-5.314 5.311 5.313 5.313 0 0 1-5.314-5.311 5.313 5.313 0 0 1 5.314-5.311 5.313 5.313 0 0 1 5.314 5.311z" clip-rule="evenodd" class="colorF7E3C7 svgShape"></path><path fill="#8526fe" d="M103.53 104.238c-3.757 0-6.813-3.055-6.813-6.811s3.057-6.811 6.813-6.811c3.757 0 6.814 3.055 6.814 6.811s-3.056 6.811-6.814 6.811zm0-10.622a3.816 3.816 0 0 0-3.813 3.811 3.817 3.817 0 0 0 3.813 3.811 3.817 3.817 0 0 0 3.814-3.811 3.816 3.816 0 0 0-3.814-3.811z" class="color3A312A svgShape"></path><path fill="#f7e4c7" d="M103.897 94.849c0 13.003-12.529 32.961-23.556 32.961-10.525 0-23.556-19.958-23.556-32.961s10.546-23.544 23.556-23.544c13.009 0 23.556 10.541 23.556 23.544z" class="colorF7E3C7 svgShape"></path><path fill="#8526fe" d="M80.341 129.31c-11.617 0-25.056-20.855-25.056-34.462 0-13.809 11.24-25.043 25.056-25.043s25.056 11.234 25.056 25.043c-.001 13.921-13.199 34.462-25.056 34.462zm0-56.505c-12.162 0-22.056 9.889-22.056 22.043 0 12.938 12.986 31.461 22.056 31.461 10.013 0 22.056-19.324 22.056-31.461-.001-12.154-9.895-22.043-22.056-22.043z" class="color3A312A svgShape"></path><path fill="#8526fe" d="M74.323 94.583a2.298 2.298 0 1 1-4.597 0 2.298 2.298 0 0 1 4.597 0zm16.634 0a2.298 2.298 0 1 1-4.597 0 2.298 2.298 0 0 1 4.597 0z" class="color3A312A svgShape"></path><path fill="#f5ca89" d="M71.39 101.415c0 1.634-1.773 2.959-3.961 2.959-2.187 0-3.961-1.325-3.961-2.959s1.773-2.959 3.961-2.959c2.187 0 3.961 1.325 3.961 2.959zm25.823 0c0 1.634-1.773 2.959-3.96 2.959-2.188 0-3.961-1.325-3.961-2.959s1.773-2.959 3.961-2.959c2.187 0 3.96 1.325 3.96 2.959z" class="colorF59689 svgShape"></path><path fill="#8526fe" d="M80.34 115.446c-3.668 0-6.313-1.65-7.864-4.904a1.5 1.5 0 1 1 2.709-1.289c1.038 2.179 2.676 3.194 5.155 3.194 2.899 0 4.641-1.839 5.104-3.075a1.5 1.5 0 0 1 2.81 1.052c-.907 2.418-3.77 5.022-7.914 5.022z" class="color3A312A svgShape"></path><path fill="#ad59d4" d="M80.613 66.109c-13.465 0-24.381 10.431-24.381 23.299 0 1.361.246 2.376.705 3.644.216.598 3.707-1.311 4.005-1.52 1.486-1.046 2.701-2.464 3.609-4.031.375-.652.689-1.315.94-1.979.804-2.116 2.987-8.005 5.205-7.543 2.973.62 6.343.97 9.918.97 3.575 0 6.945-.35 9.918-.97 2.217-.462 4.401 5.427 5.204 7.543.252.664.565 1.327.94 1.979 1.5 2.593 4.033 5.062 7.115 5.511.008-.149.196-.2.336-.25 1.009-.366.867-2.545.867-3.354 0-12.868-10.916-23.299-24.381-23.299z" class="color87796F svgShape"></path><path fill="#8526fe" d="M57.116 94.651a1.74 1.74 0 0 1-.52-.071 1.656 1.656 0 0 1-1.071-1.019c-.477-1.316-.794-2.527-.794-4.153 0-13.674 11.61-24.799 25.882-24.799 14.271 0 25.881 11.124 25.881 24.798l.002.251c.018 1.196.054 3.64-1.665 4.433a1.499 1.499 0 0 1-1.257.405c-3.136-.457-6.2-2.792-8.197-6.244a15.3 15.3 0 0 1-1.045-2.198l-.05-.131c-2.069-5.458-3.173-6.329-3.512-6.462-3.171.655-6.588.987-10.158.987-3.571 0-6.988-.332-10.158-.987-.339.133-1.443 1.003-3.513 6.462l-.05.131a15.204 15.204 0 0 1-1.043 2.195c-1.064 1.837-2.463 3.395-4.046 4.51-.03.021-2.95 1.892-4.686 1.892zm48.172-1.558zM90.81 76.448c2.699 0 4.611 4.015 6.278 8.411l.049.13c.227.598.509 1.191.838 1.763 1.399 2.418 3.388 4.114 5.415 4.649.083-.298.118-.867.106-1.699l-.003-.295c0-12.02-10.265-21.798-22.881-21.798-12.617 0-22.882 9.779-22.882 21.798 0 .739.086 1.349.243 1.96.779-.339 1.792-.864 2.127-1.079 1.207-.851 2.305-2.081 3.151-3.541.327-.568.609-1.162.836-1.759l.049-.13c1.785-4.708 3.855-8.974 6.864-8.349 2.945.613 6.269.938 9.612.938 3.39 0 6.623-.316 9.612-.938.2-.041.395-.061.586-.061z" class="color3A312A svgShape"></path><path fill="#ad59d4" d="M80.31 55c-.384 0-7.584 3.133-12.035 6.332-3.781 2.718-6.457 5.341-6.457 8.051 0 6.683 8.279 12.1 18.492 12.1 10.213 0 18.492-5.417 18.492-12.1S80.538 55 80.31 55z" class="color87796F svgShape"></path><path fill="#8526fe" d="M80.31 82.983c-11.024 0-19.992-6.101-19.992-13.6 0-3.682 3.58-6.751 7.081-9.268 4.19-3.012 11.864-6.615 12.911-6.615.896 0 19.992 7.985 19.992 15.883 0 7.499-8.968 13.6-19.992 13.6zm-.03-26.397c-1.598.623-7.369 3.261-11.13 5.964-2.503 1.8-5.832 4.466-5.832 6.832 0 5.845 7.622 10.6 16.992 10.6 9.37 0 16.992-4.755 16.992-10.6 0-4.703-13.635-11.451-17.022-12.796z" class="color3A312A svgShape"></path><path fill="#ad59d4" d="m172.856 184.144 22.249 22.233c.33-.749.805-1.45 1.418-2.062l7.032-7.032a6.809 6.809 0 0 1 2.062-1.418l-22.241-22.241-10.52 10.52z" class="color87796F svgShape"></path><path fill="#8526fe" d="M195.105 207.877c-.394 0-.776-.155-1.06-.439l-22.249-22.232a1.498 1.498 0 0 1-.001-2.122l10.52-10.52a1.5 1.5 0 0 1 2.121 0l22.241 22.24a1.5 1.5 0 0 1-.455 2.432 5.305 5.305 0 0 0-1.607 1.107l-7.032 7.032a5.272 5.272 0 0 0-1.106 1.607 1.5 1.5 0 0 1-1.372.895zm-20.128-23.733 19.843 19.829c.199-.25.413-.49.642-.718l7.032-7.032c.229-.229.468-.442.718-.641l-19.836-19.835-8.399 8.397z" class="color3A312A svgShape"></path><circle cx="150.456" cy="151.22" r="50.406" fill="#ad59d4" transform="rotate(-39.249 150.445 151.215)" class="color87796F svgShape"></circle><path fill="#8526fe" d="M150.456 203.102c-13.292 0-26.584-5.059-36.703-15.178-9.804-9.804-15.203-22.839-15.203-36.703 0-13.865 5.399-26.899 15.203-36.703 20.237-20.239 53.167-20.24 73.406 0 20.238 20.238 20.238 53.168 0 73.406-10.119 10.118-23.411 15.178-36.703 15.178zm-34.582-17.299c19.069 19.068 50.095 19.067 69.164-.001 19.068-19.068 19.068-50.095 0-69.163-19.068-19.068-50.096-19.068-69.164 0-9.237 9.237-14.324 21.518-14.324 34.582 0 13.063 5.087 25.344 14.324 34.582z" class="color3A312A svgShape"></path><path fill="#5fe4d4" d="M122.909 178.768c15.214 15.214 39.88 15.214 55.094 0 15.214-15.214 15.214-39.88 0-55.094-15.214-15.214-39.88-15.214-55.094 0-15.214 15.213-15.214 39.88 0 55.094z" class="color8AC6DD svgShape"></path><path fill="#8526fe" d="M150.456 191.659c-10.36 0-20.72-3.944-28.607-11.831-15.774-15.774-15.774-41.441 0-57.215 15.774-15.773 41.441-15.774 57.215 0s15.774 41.441 0 57.215c-7.888 7.887-18.248 11.831-28.608 11.831zm0-77.879c-9.592 0-19.185 3.651-26.487 10.954-14.605 14.605-14.605 38.369 0 52.973 14.604 14.604 38.369 14.605 52.973 0 14.605-14.605 14.605-38.368 0-52.973-7.302-7.302-16.894-10.954-26.486-10.954z" class="color3A312A svgShape"></path><path fill="#f1bc6c" d="M236.971 220.907a6.929 6.929 0 0 1 0 9.799l-7.029 7.029a6.929 6.929 0 0 1-9.799 0l-23.623-23.623a6.929 6.929 0 0 1 0-9.799l7.029-7.029a6.929 6.929 0 0 1 9.799 0l23.623 23.623z" class="colorF16C7A svgShape"></path><path fill="#8526fe" d="M225.042 241.265a8.371 8.371 0 0 1-5.96-2.469l-23.623-23.623c-3.287-3.286-3.287-8.634 0-11.92l7.029-7.029c3.287-3.288 8.635-3.287 11.92 0l23.623 23.623a8.374 8.374 0 0 1 2.469 5.96 8.373 8.373 0 0 1-2.469 5.96l-7.029 7.029a8.371 8.371 0 0 1-5.96 2.469zm-16.594-44.511c-1.45 0-2.814.565-3.839 1.59l-7.029 7.029c-1.025 1.025-1.59 2.389-1.59 3.839s.565 2.813 1.59 3.839l23.623 23.623a5.395 5.395 0 0 0 3.839 1.59c1.45 0 2.814-.565 3.839-1.59l7.029-7.029a5.435 5.435 0 0 0 0-7.678l-23.623-23.623a5.395 5.395 0 0 0-3.839-1.59z" class="color3A312A svgShape"></path><path fill="#decaad" d="M160.73 45.76h-15c3.07 0 5.57 2.5 5.57 5.57v48.04c5.06.07 10.13.89 15 2.44V51.33c0-3.07-2.5-5.57-5.57-5.57zm-9.43 157.32v17.32c0 3.07-2.5 5.57-5.57 5.57h15c3.07 0 5.57-2.5 5.57-5.57v-19.77a51.914 51.914 0 0 1-15 2.45z" class="colorDECAAD svgShape"></path></svg>
                                                </div>
                                                <div class="tracking-content">Background<span>
                                                    <p className='m-0'>{ITEM?.mothertongue}</p>
                                                    <p className='m-0'>{ITEM?.maritalstatus}</p>
                                                </span></div>
                                            </div>
                                            <div class="tracking-item">
                                                <div class="tracking-icon status-intransit">
                                                    <svg class="svg-inline--fa fa-circle fa-w-16 w-100 h-100" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 132 132" width="256" height="256"><path fill="#53d86a" d="M0 0h132v132H0z" class="colorf5fcff svgShape"></path><path fill="#595bd4" d="M122 50.9c-.3 0-.5-.2-.5-.5v-3.7c0-.3.2-.5.5-.5s.5.2.5.5v3.7c0 .2-.2.5-.5.5z" class="colora06ff3 svgShape"></path><path fill="#167ffc" d="M10.2 106.4h14.7v5.1H10.2z" class="colorfff svgShape"></path><path fill="#c0c1ff" d="M24.9 112H10.2c-.3 0-.5-.2-.5-.5v-5.1c0-.3.2-.5.5-.5h14.7c.3 0 .5.2.5.5v5.1c0 .3-.2.5-.5.5zm-14.2-1h13.7v-4.1H10.7v4.1z" class="colorc0e6ff svgShape"></path><path fill="#167ffc" d="M5 97.9h19.8v5.1H5z" class="colorfff svgShape"></path><path fill="#c0c1ff" d="M24.9 103.5H5c-.3 0-.5-.2-.5-.5v-5.1c0-.3.2-.5.5-.5h19.8c.3 0 .5.2.5.5v5.1c.1.3-.1.5-.4.5zm-19.4-1h18.8v-4.1H5.5v4.1z" class="colorc0e6ff svgShape"></path><path fill="#167ffc" d="M105.5 31.4h13.2v5.1h-13.2z" class="colorfff svgShape"></path><path fill="#c0c1ff" d="M118.7 37h-13.2c-.3 0-.5-.2-.5-.5v-5.1c0-.3.2-.5.5-.5h13.2c.3 0 .5.2.5.5v5.1c0 .3-.2.5-.5.5zM106 36h12.2v-4.1H106V36z" class="colorc0e6ff svgShape"></path><path fill="#167ffc" d="M105.5 22.9h19.8V28h-19.8z" class="colorfff svgShape"></path><path fill="#c0c1ff" d="M125.4 28.4h-19.8c-.3 0-.5-.2-.5-.5v-5.1c0-.3.2-.5.5-.5h19.8c.3 0 .5.2.5.5v5.1c0 .3-.2.5-.5.5zm-19.4-1h18.8v-4.1H106v4.1z" class="colorc0e6ff svgShape"></path><path fill="#d7d8ff" d="M128.9 110.5c-.2.9-1 1.5-1.8 1.5h-17c-1.3 0-2.4 1.1-2.3 2.5.1 1.2 1.2 2.2 2.4 2.2h10.6c1.3 0 2.4 1.1 2.4 2.5-.1 1.3-1.2 2.2-2.5 2.2h-4.3c-.8 0-1.6.6-1.8 1.4-.2 1.1.6 2 1.7 2h8c.7 0 1.4.3 1.9.8s.8 1.1.8 1.9c0 1.5-1.2 2.6-2.6 2.6H89.6c-.6 0-1.2-.2-1.5-.6-.4-.4-.6-.9-.6-1.5 0-1.2 1-2.2 2.2-2.2h5.8c.9 0 1.7-.8 1.7-1.7 0-1-.8-1.7-1.7-1.7h-8.7c-.9 0-1.7-.4-2.2-.9-.6-.6-.9-1.4-.9-2.2 0-1.8 1.4-3.2 3.2-3.2h11.7c.9 0 1.5-.7 1.5-1.5v-.1c0-.8-.7-1.5-1.5-1.5h-4.1c-1.1 0-2-1-1.9-2.1.1-1 1-1.7 2-1.7h18.8c.9 0 1.7-.8 1.5-1.8-.1-.8-.8-1.3-1.6-1.3h-22c-1.7 0-3-1.4-3-3 0-.8.3-1.6.9-2.1.5-.6 1.3-.9 2.1-.9h34.2c1.5 0 2.7 1.3 2.6 2.8-.1 1.4-1.3 2.5-2.8 2.5H122c-.5 0-.9.2-1.2.5-.3.3-.5.7-.5 1.2 0 1 .8 1.7 1.7 1.7h5c1.3-.4 2.1.6 1.9 1.7zM51.3 12.8c-.2.9-1 1.5-1.8 1.5h-17c-1.3 0-2.4 1.1-2.3 2.5.1 1.2 1.2 2.2 2.4 2.2h10.6c1.3 0 2.4 1.1 2.4 2.5-.1 1.3-1.2 2.2-2.5 2.2h-4.3c-.8 0-1.6.6-1.8 1.4-.2 1.1.6 2 1.7 2h8c.7 0 1.4.3 1.9.8s.8 1.1.8 1.9c0 1.5-1.2 2.6-2.6 2.6H11.9c-.6 0-1.2-.2-1.5-.6-.4-.4-.6-.9-.6-1.5 0-1.2 1-2.2 2.2-2.2h5.8c.9 0 1.7-.8 1.7-1.7 0-1-.8-1.7-1.7-1.7H9.1c-.9 0-1.7-.4-2.2-.9-.6-.6-.9-1.4-.9-2.2 0-1.8 1.4-3.2 3.2-3.2h11.7c.9 0 1.5-.7 1.5-1.5v-.1c0-.8-.7-1.5-1.5-1.5h-4.1c-1.1 0-2-1-1.9-2.1.1-1 1-1.7 2-1.7h18.8c.9 0 1.7-.8 1.5-1.8-.1-.8-.8-1.3-1.6-1.3h-22c-1.7 0-3-1.4-3-3 0-.8.3-1.6.9-2.1.6-1 1.3-1.3 2.2-1.3h34.2c1.5 0 2.7 1.3 2.6 2.8-.1 1.4-1.3 2.5-2.8 2.5h-3.3c-.5 0-.9.2-1.2.5-.2.3-.4.7-.4 1.2 0 1 .8 1.7 1.7 1.7h5c1.1 0 1.9 1 1.8 2.1z" class="colord7f1ff svgShape"></path><circle cx="64.9" cy="66" r="31" fill="#167ffc" class="colorfff svgShape"></circle><path fill="#fe9526" d="M78.6 78.6c0-7-5.7-12.6-12.6-12.6-7 0-12.6-5.7-12.6-12.6 0-4.2 2.1-8 5.3-10.3C48.5 45.8 41.1 55 41.1 66c0 13.1 10.7 23.8 23.8 23.8 3.5 0 6.8-.8 9.8-2.1 2.4-2.3 3.9-5.5 3.9-9.1z" class="colorffa573 svgShape"></path><path fill="#7c7eff" d="M88.7 66c0-13.1-10.7-23.8-23.8-23.8-2.2 0-4.3.3-6.3.8-3.2 2.3-5.3 6-5.3 10.3 0 7 5.7 12.6 12.6 12.6 7 0 12.6 5.7 12.6 12.6 0 3.6-1.5 6.8-3.9 9.1 8.4-3.7 14.1-12 14.1-21.6z" class="color7cc7ff svgShape"></path><path fill="#167ffc" d="M68 54.1c0 1.7-1.4 3.1-3.1 3.1-1.7 0-3.1-1.4-3.1-3.1 0-1.7 1.4-3.1 3.1-3.1 1.7 0 3.1 1.4 3.1 3.1zm0 23.8c0 1.7-1.4 3.1-3.1 3.1-1.7 0-3.1-1.4-3.1-3.1 0-1.7 1.4-3.1 3.1-3.1 1.7 0 3.1 1.4 3.1 3.1z" class="colorfff svgShape"></path><circle cx="64.9" cy="14.6" r="10" fill="#c0c1ff" class="colorc0e6ff svgShape"></circle><circle cx="28.6" cy="29.7" r="10" fill="#feae59" class="colorfee459 svgShape"></circle><circle cx="13.5" cy="66" r="10" fill="#c0c1ff" class="colorc0e6ff svgShape"></circle><circle cx="28.6" cy="102.3" r="10" fill="#feae59" class="colorfee459 svgShape"></circle><circle cx="64.9" cy="117.4" r="10" fill="#c0c1ff" class="colorc0e6ff svgShape"></circle><circle cx="101.2" cy="102.3" r="10" fill="#feae59" class="colorfee459 svgShape"></circle><circle cx="116.3" cy="66" r="10" fill="#c0c1ff" class="colorc0e6ff svgShape"></circle><circle cx="101.2" cy="29.7" r="10" fill="#feae59" class="colorfee459 svgShape"></circle><g fill="#17198d" class="color175d8d svgShape"><path d="M74.9 88.1c24.7-11.2 14.7-47.9-10.5-46.4-14.2.3-24.7 13-23.8 24.7.3 17.3 18.2 29 34.3 21.7zm-16-44.6c25.6-6.9 41.4 28.6 17.9 42.5 5.9-8.3 0-20.5-10.7-20.6h-.9c-4.8-.1-9.8-3.9-11-9.6-1.2-4.7 1-9.6 4.7-12.3zM41.6 66.4C41 57.7 47 48 56.4 44.3c-.2.1-.3.3-.4.5-7.4 8.6-1.2 21.7 9.9 21.7h.2c10.7.2 16 13.2 8.2 20.8-15.1 6.8-32.4-4.2-32.7-20.9z" fill="#000000" class="color000 svgShape"></path><path d="M64.9 57.7c2 0 3.6-1.6 3.6-3.6s-1.6-3.6-3.6-3.6c-1.9 0-3.6 1.6-3.6 3.6s1.7 3.6 3.6 3.6zm0-6.2c1.4 0 2.6 1.2 2.6 2.6 0 1.4-1.2 2.6-2.6 2.6-1.4 0-2.6-1.2-2.6-2.6 0-1.4 1.2-2.6 2.6-2.6zm3.6 26.4c0-2-1.6-3.6-3.6-3.6-1.9 0-3.6 1.6-3.6 3.6s1.6 3.6 3.6 3.6 3.6-1.6 3.6-3.6zm-3.6 2.6c-1.4 0-2.6-1.2-2.6-2.6 0-1.4 1.2-2.6 2.6-2.6 1.4 0 2.6 1.2 2.6 2.6 0 1.4-1.2 2.6-2.6 2.6z" fill="#000000" class="color000 svgShape"></path><path d="M115.7 55.5c-1.3-6.5-3.9-12.6-7.5-18 2.1-1.8 3.5-4.7 3.5-7.8 0-5.8-4.7-10.5-10.5-10.5-3.3 0-6.3 1.6-7.8 3.5-5.4-3.6-11.5-6.1-18-7.5v-.6c0-5.8-4.7-10.5-10.5-10.5S54.4 8.8 54.4 14.6v.6c-6.5 1.4-12.6 3.9-18 7.5-1.5-1.9-4.6-3.5-7.8-3.5-5.8 0-10.5 4.7-10.5 10.5 0 3.1 1.4 6 3.5 7.8-3.5 5.4-6.1 11.5-7.5 18h-.6C7.7 55.5 3 60.2 3 66s4.7 10.5 10.5 10.5h.6c1.3 6.5 3.9 12.6 7.5 18l-.4.4c-2 2-3.1 4.6-3.1 7.4 0 5.8 4.7 10.5 10.5 10.5 2.8 0 5.5-1.1 7.4-3.1l.4-.4c5.4 3.5 11.5 6.1 18 7.5 0 7 5.2 11.1 10.5 11.1 5.8 0 10.5-4.7 10.5-10.5v-.6c6.5-1.3 12.6-3.9 18-7.5 1.5 1.9 4.6 3.5 7.8 3.5 5.8 0 10.5-4.7 10.5-10.5 0-2.8-1.1-5.4-3.1-7.4l-.4-.4c3.5-5.4 6.1-11.5 7.5-18 7.1 0 11.1-5.2 11.1-10.5s-4.1-10.5-11.1-10.5zm-1 .1c-4.9.7-8.6 4.8-8.9 9.8h-9.3c-.2-8.3-3.5-15.8-8.9-21.4l6.6-6.6c1.9 1.8 4.5 2.8 7.1 2.8 2.1 0 4.3-.6 6.2-2 3.4 5.2 5.9 11.1 7.2 17.4zM34.4 66.4c-1.1-14.8 12.3-30.9 30.5-30.9 7.9 0 15.5 3.1 21.2 8.6l.7.7c5.2 5.4 8.5 12.7 8.7 20.7v1C95.3 83.2 81.7 96.6 65 96.6c-16.8-.1-30.4-13.5-30.6-30.2zm66.8-46.2c5.3 0 9.5 4.3 9.5 9.5 0 1.3-.3 2.5-.7 3.6-1.4 3.4-4.7 5.9-8.8 5.9-5.4 0-9.5-4.4-9.5-9.5 0-5.3 4.3-9.5 9.5-9.5zm-8.4 3.3c-1.3 1.8-2 4-2 6.2 0 2.6 1 5.1 2.7 7l-6.6 6.6c-5.6-5.4-13.1-8.7-21.4-8.8v-9.3c5-.2 9.2-4 9.9-8.9 6.2 1.2 12.1 3.7 17.4 7.2zm-37.4-8.9c0-5.2 4.3-9.5 9.5-9.5 5.7 0 9.9 5.1 9.5 9.9-.1 4.9-4.3 9.1-9.5 9.1-5.3 0-9.5-4.2-9.5-9.5zm-.9 1.6c.7 4.9 4.9 8.7 9.9 8.9v9.3c-8.3.1-15.8 3.5-21.4 8.8l-6.6-6.6c1.8-2 2.7-4.5 2.7-7 0-2.2-.7-4.4-2-6.2 5.2-3.4 11.1-5.9 17.4-7.2zM19.1 29.7c0-5.2 4.2-9.5 9.5-9.5 7.7 0 13.2 9.1 6.4 16.5-1.8 1.6-4 2.5-6.4 2.5-5.3 0-9.5-4.3-9.5-9.5zm3.3 8.4c1.8 1.3 4 2 6.2 2 2.7 0 5.2-1 7.1-2.8l6.6 6.6c-5.4 5.6-8.8 13.1-8.9 21.4H24c-.3-5-4.1-9.1-8.9-9.8 1.3-6.2 3.8-12.1 7.3-17.4zm-8.5 37.4C9.1 75.9 4 71.7 4 66c0-5.8 5.2-10.3 10.9-9.4 4.4.6 7.8 4.3 8.1 8.8.3 5.7-4.1 10-9.1 10.1zm1.2.9c4.9-.7 8.7-4.9 8.9-10h9.3c.1 8.3 3.5 15.9 8.8 21.5l-6.6 6.6c-1.9-1.7-4.4-2.7-7-2.7-2.2 0-4.3.7-6.2 2-3.4-5.2-5.9-11.1-7.2-17.4zm13.5 35.4c-5.3 0-9.5-4.3-9.5-9.5s4.2-9.5 9.5-9.5c2.9 0 5.1 1.1 7 3.1 5.6 6.1 1.2 15.9-7 15.9zm8.5-3.3c2.9-4 2.7-9.6-.7-13.4l6.6-6.6c5.6 5.4 13.1 8.8 21.5 8.9v9.3c-5 .2-9.2 4-9.9 8.9-6.4-1.1-12.3-3.6-17.5-7.1zm27.8 18.4c-5.8 0-10.3-5.2-9.4-10.9 1.6-10.8 17.2-10.8 18.8 0 .9 6-3.9 10.9-9.4 10.9zm10.4-11.1c-.7-4.9-4.9-8.7-9.9-8.9v-9.3c8.3-.1 15.9-3.5 21.5-8.9l6.6 6.6c-1.8 2-2.8 4.5-2.8 7.1 0 1.4.3 2.8.8 4 .3.8.7 1.5 1.3 2.2-5.3 3.4-11.2 5.9-17.5 7.2zm35.4-13.5c0 5.2-4.2 9.5-9.5 9.5-5.2 0-9.5-4.2-9.5-9.5s4.4-9.5 9.5-9.5c5.3 0 9.5 4.3 9.5 9.5zm-3.2-8.5c-1.8-1.3-3.9-2-6.2-2-2.6 0-5.1 1-7 2.7l-6.6-6.6c5.4-5.6 8.7-13.2 8.8-21.5h9.3c.2 5.1 4 9.3 8.9 10-1.3 6.3-3.8 12.2-7.2 17.4zm7.4-18.4c-4.6-.7-8.4-4.8-8.1-10 .3-4.5 3.7-8.2 8.1-8.8 5.7-.9 10.9 3.6 10.9 9.4 0 5.8-5.2 10.3-10.9 9.4z" fill="#000000" class="color000 svgShape"></path><path d="M64.4 17.1v1.4H63c-.3 0-.5.2-.5.5s.2.5.5.5h1.4V20.9c0 .2.2.4.5.4s.5-.2.5-.5v-1.3h1.4c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-1.4v-1.4c2.2-.2 4-2.1 4-4.5 0-2.5-2-4.5-4.5-4.5s-4.5 2-4.5 4.5c0 2.3 1.8 4.2 4 4.5zm.5-8.1c2 0 3.5 1.6 3.5 3.5 0 2-1.7 3.5-3.5 3.5-1.9 0-3.5-1.5-3.5-3.5 0-1.9 1.6-3.5 3.5-3.5zm33.2 23v.2c-.9 1.1-1 2.6-.4 3.8.1.3.4.4.7.3.3-.1.4-.4.3-.7-.4-.9-.3-2 .3-2.8h4.6c.2.2.3.4.5.6.3.7.3 1.5 0 2.2-.1.3 0 .5.3.7h.2c.2 0 .4-.1.5-.3.4-1.1.4-2.1 0-3.1-.1-.3-.3-.5-.4-.7v-5c.8-1.1 1-2.5.4-3.8-.1-.3-.4-.4-.7-.3-.3.1-.4.4-.3.7.4.9.3 1.9-.3 2.8H99c-.5-.8-.7-1.8-.3-2.8.1-.3 0-.5-.3-.7s-.6 0-.7.3c-.3.7-.4 1.5-.3 2.2.1.6.3 1.1.7 1.6V32zm1-4.5h4.3v4.3h-4.3v-4.3zm17.6 32.1c-.1 0-.4-.5-.7-.1l-4.3 4.3c-.2.2-.2.5 0 .7.2.2.5.2.7 0l3.4-3.4c0 4.7 0 6-.1 7.2h-2.9c-.3 0-.5.2-.5.5s.2.5.5.5h3v2.9c0 .3.2.5.5.5h.1c.2 0 .4-.3.4-.5v-2.9h3c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-3v-7.2l3.4 3.4c.1.1.2.2.4.2.1 0 .3 0 .3-.2.2-.2.2-.5 0-.7l-4.2-4.2zm-15.4 38.9c-2 0-3.6 2-3 4h-3.2c-.3 0-.5.2-.5.5s.2.5.5.5h4.1c.1 0 .3-.1.3-.2v-.1c.1-.4-.7-1-.3-2.2.3-.8 1-1.5 2-1.5 1.6 0 2.7 1.8 1.8 3.2-.1.1-.1.3 0 .5s.3.3.4.3h3.9c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-3.1c.7-1.9-.8-4-2.9-4zm6.1 6.6H95.1c-.3 0-.5.2-.5.5s.2.5.5.5h12.3c.3 0 .5-.2.5-.5s-.3-.5-.5-.5zm-37 7.8c-.1-.1-.3-.2-.4-.2-.1 0-.3.1-.4.2l-2 2.8-.7-2.6c-.1-.2-.2-.3-.4-.4-.2 0-.4 0-.5.2-.1.1-2.3 2.9-2.2 2.8l-1.1-2.6c-.1-.2-.2-.3-.4-.3s-.4 0-.5.2l-3 3.6c-.2.2-.1.5.1.7.5.5 1-.4 1.1-.5l2.1-2.5 1.1 2.7c.1.2.2.3.4.3s.4 0 .5-.2l.1-.1c.7-.9 2.1-2.7 2-2.6 0 .1.8 2.8.8 2.6.1.2.3.4.5.4.4 0 .5-.3.6-.5l2-2.7 1.2 1.6c.2.2.5.3.7.1.2-.2.3-.5.1-.7l-1.7-2.3zm-.9 5.3c-.1-.1-.3-.2-.4-.2-.4 0-.4.3-2.5 3-.8-2.4-.6-2.8-1.1-3h-.1c-.2 0-.3.1-.4.2l-.5.6-1.7 2.1-1.1-2.6c-.1-.2-.2-.3-.4-.3s-.4 0-.5.2l-3 3.6c-.2.2-.2.5.1.7.2.2.5.2.7-.1l2.5-3 1.1 2.7c.1.2.2.3.4.3s.4 0 .5-.2l2.1-2.7.8 2.6c0 .2.2.3.4.4h.1c.2 0 .3-.1.4-.2l2.2-3 1.2 1.6c.2.2.5.3.7.1.2-.2.3-.5.1-.7l-1.6-2.1zM33 95.7c-.3 0-.5.2-.5.5 0 .5-.2 1.1-.5 1.5-.6-1-2.2-1.9-3.9-1.7-1.2.1-2.3.8-2.9 1.8l-.1-.1c-.3-.4-.4-.9-.4-1.4 0-.3-.2-.5-.5-.5-.2 0-.3.1-.4.2-.1.1-.1.2-.1.3 0 .7.2 1.4.6 1.9v.1c.1.2.2.3.3.5-.2.4-.3.9-.3 1.4 0 2.1 1.6 3.9 3.7 4.2v2.2h-1.2c-.3 0-.5.2-.5.5s.2.5.5.5H28v1c0 .3.2.5.5.5s.5-.2.5-.5v-1h1.2c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H29v-2.2c.2 0 .5-.1.7-.1 2.2-.6 3.5-3 2.8-5.2 0-.1 0-.1-.1-.2.5-.6.8-1.3.9-2v-.4c.2-.6 0-.8-.3-.8zm-5.7 7.3c-2.2-1-2.2-3.8-1.4-4.5.2-.5 1.2-1.4 2.3-1.5 1.7-.2 3.4 1 3.6 2.8.2 2.5-2.3 4.2-4.5 3.2zm-9.1-39.6c0 .7-.6 1-.8 1.3-.2.2-.2.5 0 .7.2.2.5.2.7 0 .2-.2 1.1-.8 1.1-2 0-2-2.5-3-3.9-1.6-.8.8-1.4 1.8-1.8 2.8-2.3-6.6-7.5-2.1-4.9.4l.4.4c.2.2.5.2.7 0 .2-.2.2-.5 0-.7l-.4-.5c-1.2-1.2.6-3 1.8-1.8.8.8 1.4 1.8 1.7 2.9.1.3.2.7.2 1 .1.7 0 1 .1 4 0 .3.2.5.5.5s.5-.2.5-.5v-4c0-.3.1-.7.2-1 .3-1.1.9-2.1 1.7-2.9.8-.7 2.2-.1 2.2 1zm6.4-29c-.2.2-.3.5-.1.7.2.2.5.2.7 0 1.5-1.2 2.1-3.5 2.1-5.4h2.6c0 1.9.7 4.2 2.1 5.4.2.2.5.2.7-.1.2-.2.1-.5-.1-.7-1.2-1-1.7-3-1.8-4.6h1.4c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-1.3c.1-.8.3-1.8.7-2.5.3-.5.6-1 1-1.3.2-.2.3-.5.1-.7-.2-.2-.5-.2-.7 0-1.3 1-1.9 2.9-2.1 4.6h-2.6c-.2-2-.9-3.7-2.1-4.6-.2-.2-.6-.2-.7.1-.2.2-.1.5.1.7.9.7 1.5 2.2 1.7 3.8H25c-.3 0-.5.2-.5.5s.2.5.5.5h1.4c-.1 1.6-.6 3.6-1.8 4.6z" fill="#000000" class="color000 svgShape"></path></g><path fill="#595bd4" d="M122 44.7c-.3 0-.5-.2-.5-.5V10h-17.7c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H122c.3 0 .5.2.5.5v34.8c0 .2-.2.4-.5.4zM13.5 86.5c-.3 0-.5-.2-.5-.5v-3.8c0-.3.2-.5.5-.5s.5.2.5.5V86c0 .3-.2.5-.5.5zM20.4 117.9h-6.9c-.3 0-.5-.2-.5-.5v-28c0-.3.2-.5.5-.5s.5.2.5.5v27.5h6.4c.3 0 .5.2.5.5s-.2.5-.5.5z" class="colora06ff3 svgShape"></path><g fill="#9c9df4" class="color9cc8f4 svgShape"><path d="M10.5 43.6H6.3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4.3c.3 0 .5.2.5.5s-.3.5-.6.5z" fill="#000000" class="color000 svgShape"></path><path d="M8.4 45.7c-.3 0-.5-.2-.5-.5v-4.3c0-.3.2-.5.5-.5s.5.2.5.5v4.3c0 .3-.2.5-.5.5z" fill="#000000" class="color000 svgShape"></path></g><g fill="#9c9df4" class="color9cc8f4 svgShape"><path d="M92.7 10h-4.3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4.3c.3 0 .5.2.5.5s-.3.5-.5.5z" fill="#000000" class="color000 svgShape"></path><path d="M90.5 12.1c-.3 0-.5-.2-.5-.5V7.3c0-.3.2-.5.5-.5s.5.3.5.5v4.3c0 .3-.2.5-.5.5z" fill="#000000" class="color000 svgShape"></path></g><g fill="#9c9df4" class="color9cc8f4 svgShape"><path d="M124.2 87.3h-4.3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4.3c.3 0 .5.2.5.5s-.3.5-.5.5z" fill="#000000" class="color000 svgShape"></path><path d="M122 89.4c-.3 0-.5-.2-.5-.5v-4.3c0-.3.2-.5.5-.5s.5.2.5.5v4.3c0 .3-.2.5-.5.5z" fill="#000000" class="color000 svgShape"></path></g><g fill="#9c9df4" class="color9cc8f4 svgShape"><path d="M40.7 124.2h-4.3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4.3c.3 0 .5.2.5.5s-.2.5-.5.5z" fill="#000000" class="color000 svgShape"></path><path d="M38.6 126.3c-.3 0-.5-.2-.5-.5v-4.3c0-.3.2-.5.5-.5s.5.2.5.5v4.3c0 .3-.2.5-.5.5z" fill="#000000" class="color000 svgShape"></path></g></svg>
                                                </div>
                                                <div class="tracking-content">Horoscope Details<span>
                                                    <p className='m-0'>{ITEM?.raashi}</p>
                                                    <p className='m-0'>{ITEM?.star}</p>
                                                </span></div>
                                            </div>
                                            <div class="tracking-item">
                                                <div class="tracking-icon status-intransit">
                                                    <img class="app-preview__image-origin svg-inline--fa fa-circle fa-w-16 w-100 h-100" srcset="https://img.icons8.com/?size=256&amp;id=eco2vZUxsc9M&amp;format=png 1x, https://img.icons8.com/?size=512&amp;id=eco2vZUxsc9M&amp;format=png 2x" alt="Family icon" data-v-6be23ab2="" />
                                                </div>
                                                <div class="tracking-content">Family Details<span>
                                                    <p className='m-0'>My father is employed and my mother is house wife.</p>
                                                </span></div>
                                            </div>
                                            <div class="tracking-item">
                                                <div class="tracking-icon status-intransit">
                                                    <svg class="svg-inline--fa fa-circle fa-w-16 w-100 h-100" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 128 128" width="256" height="256"><path fill="#2d4356" d="M57.86,40.32l-5.42-6.53a2.033,2.033,0,0,0-1.54-.72H35.74a2.033,2.033,0,0,0-1.54.72l-5.42,6.53a1.999,1.999,0,0,0,.09,2.65S41.61,56.44,41.62,56.45a2.56492,2.56492,0,0,0,3.41,0L57.77,42.97A1.988,1.988,0,0,0,57.86,40.32ZM41.32,50.31l-5.91-6.24h5.91Zm0-10.24H34.19l2.49-3h4.64Zm4,10.24V44.07h5.91Zm0-10.24v-3h4.64l2.49,3Z" class="color2d4356 svgShape"></path><polygon fill="#81d9e3" points="52.45 40.07 45.32 40.07 45.32 37.07 49.96 37.07 52.45 40.07" class="color81d9e3 svgShape"></polygon><polygon fill="#81d9e3" points="51.23 44.07 45.32 50.31 45.32 44.07 51.23 44.07" class="color81d9e3 svgShape"></polygon><polygon fill="#81d9e3" points="41.32 44.07 41.32 50.31 35.41 44.07 41.32 44.07" class="color81d9e3 svgShape"></polygon><polygon fill="#81d9e3" points="41.32 37.07 41.32 40.07 34.19 40.07 36.68 37.07 41.32 37.07" class="color81d9e3 svgShape"></polygon><path fill="#2d4356" d="M99.22,40.32,93.8,33.79a2.033,2.033,0,0,0-1.54-.72H77.1a2.033,2.033,0,0,0-1.54.72l-5.42,6.53a1.99911,1.99911,0,0,0,.09,2.65S82.97,56.44,82.98,56.45a2.56492,2.56492,0,0,0,3.41,0L99.13,42.97A1.988,1.988,0,0,0,99.22,40.32ZM82.68,50.31l-5.91-6.24h5.91Zm0-10.24H75.55l2.49-3h4.64Zm4,10.24V44.07h5.91Zm0-10.24v-3h4.64l2.49,3Z" class="color2d4356 svgShape"></path><polygon fill="#81d9e3" points="93.81 40.07 86.68 40.07 86.68 37.07 91.32 37.07 93.81 40.07" class="color81d9e3 svgShape"></polygon><polygon fill="#81d9e3" points="92.59 44.07 86.68 50.31 86.68 44.07 92.59 44.07" class="color81d9e3 svgShape"></polygon><polygon fill="#81d9e3" points="82.68 44.07 82.68 50.31 76.77 44.07 82.68 44.07" class="color81d9e3 svgShape"></polygon><polygon fill="#81d9e3" points="82.68 37.07 82.68 40.07 75.55 40.07 78.04 37.07 82.68 37.07" class="color81d9e3 svgShape"></polygon><path fill="#2d4356" d="M64.00116 11a2.0001 2.0001 0 002-2V7a2 2 0 10-4 0V9A2.0001 2.0001 0 0064.00116 11zM64.00116 23a2.0001 2.0001 0 002-2V19a2 2 0 10-4 0v2A2.0001 2.0001 0 0064.00116 23zM69.00116 16h2a2 2 0 000-4h-2a2 2 0 000 4zM57.00116 16h2a2 2 0 000-4h-2a2 2 0 100 4zM13.41 11.29a6.201 6.201 0 00-5 .55 6.2974 6.2974 0 00-2.35 2.4A6.27461 6.27461 0 00.1 19.48 6.65507 6.65507 0 005.03 27.02l7.29 1.88a3.22189 3.22189 0 002.42-.36 3.14994 3.14994 0 001.43-2l1.67-7.4A6.67264 6.67264 0 0013.41 11.29zm.52 6.97l-1.47 6.55L6.03 23.15A2.68117 2.68117 0 014.04 20.17a2.27254 2.27254 0 012.82-1.86 2.01444 2.01444 0 002.45-1.49 2.313 2.313 0 012.92-1.71A2.67215 2.67215 0 0113.93 18.26z" class="color2d4356 svgShape"></path><path fill="#fc785e" d="M13.93,18.26l-1.47,6.55L6.03,23.15A2.68117,2.68117,0,0,1,4.04,20.17a2.27254,2.27254,0,0,1,2.82-1.86,2.01444,2.01444,0,0,0,2.45-1.49,2.313,2.313,0,0,1,2.92-1.71A2.67215,2.67215,0,0,1,13.93,18.26Z" class="colorfc785e svgShape"></path><path fill="#2d4356" d="M127.9,19.48a6.27461,6.27461,0,0,0-5.96-5.24,6.2974,6.2974,0,0,0-2.35-2.4,6.201,6.201,0,0,0-5-.55A6.67264,6.67264,0,0,0,110.16,19.14l1.67,7.4a3.14994,3.14994,0,0,0,1.43,2,3.22189,3.22189,0,0,0,2.42.36l7.29-1.88A6.65507,6.65507,0,0,0,127.9,19.48ZM121.97,23.15l-6.43,1.66-1.47-6.55a2.67215,2.67215,0,0,1,1.7-3.15,2.313,2.313,0,0,1,2.92,1.71,2.01444,2.01444,0,0,0,2.45,1.49,2.27254,2.27254,0,0,1,2.82,1.86A2.68117,2.68117,0,0,1,121.97,23.15Z" class="color2d4356 svgShape"></path><path fill="#fc785e" d="M121.97,23.15l-6.43,1.66-1.47-6.55a2.67215,2.67215,0,0,1,1.7-3.15,2.313,2.313,0,0,1,2.92,1.71,2.01444,2.01444,0,0,0,2.45,1.49,2.27254,2.27254,0,0,1,2.82,1.86A2.68117,2.68117,0,0,1,121.97,23.15Z" class="colorfc785e svgShape"></path><path fill="#2d4356" d="M122.97,104.97l-7.29-1.88a3.22219,3.22219,0,0,0-2.42.36,3.14979,3.14979,0,0,0-1.43,2l-1.67,7.4a6.68907,6.68907,0,0,0,4.43005,7.86,6.20316,6.20316,0,0,0,5-.56,6.29724,6.29724,0,0,0,2.35-2.4,6.25756,6.25756,0,0,0,3.16-.99,6.34981,6.34981,0,0,0,2.8-4.24005A6.66578,6.66578,0,0,0,122.97,104.97Zm.99005,6.85a2.31641,2.31641,0,0,1-1.03,1.58,2.25579,2.25579,0,0,1-1.79.28,2.013,2.013,0,0,0-2.45,1.5,2.31428,2.31428,0,0,1-2.92,1.7,2.6669,2.6669,0,0,1-1.7-3.15l1.47-6.54,6.43,1.65A2.68722,2.68722,0,0,1,123.96,111.82Z" class="color2d4356 svgShape"></path><path fill="#fc785e" d="M123.96,111.82a2.31641,2.31641,0,0,1-1.03,1.58,2.25579,2.25579,0,0,1-1.79.28,2.013,2.013,0,0,0-2.45,1.5,2.31428,2.31428,0,0,1-2.92,1.7,2.6669,2.6669,0,0,1-1.7-3.15l1.47-6.54,6.43,1.65A2.68722,2.68722,0,0,1,123.96,111.82Z" class="colorfc785e svgShape"></path><path fill="#2d4356" d="M17.84,112.85l-1.67-7.4a3.14979,3.14979,0,0,0-1.43-2,3.22219,3.22219,0,0,0-2.42-.36l-7.29,1.88A6.66578,6.66578,0,0,0,.1,112.52,6.34981,6.34981,0,0,0,2.9,116.76a6.25756,6.25756,0,0,0,3.16.99,6.29724,6.29724,0,0,0,2.35,2.4,6.20316,6.20316,0,0,0,5,.56A6.68907,6.68907,0,0,0,17.84,112.85Zm-5.61,4.03a2.31428,2.31428,0,0,1-2.92-1.7,2.013,2.013,0,0,0-2.45-1.5,2.25579,2.25579,0,0,1-1.79-.28,2.31641,2.31641,0,0,1-1.03-1.58A2.68722,2.68722,0,0,1,6.03,108.84l6.43-1.65,1.47,6.54A2.6669,2.6669,0,0,1,12.23,116.88Z" class="color2d4356 svgShape"></path><path fill="#fc785e" d="M12.23,116.88a2.31428,2.31428,0,0,1-2.92-1.7,2.013,2.013,0,0,0-2.45-1.5,2.25579,2.25579,0,0,1-1.79-.28,2.31641,2.31641,0,0,1-1.03-1.58A2.68722,2.68722,0,0,1,6.03,108.84l6.43-1.65,1.47,6.54A2.6669,2.6669,0,0,1,12.23,116.88Z" class="colorfc785e svgShape"></path><path fill="#2d4356" d="M64.00116 105a2.0001 2.0001 0 00-2 2v2a2 2 0 104 0v-2A2.0001 2.0001 0 0064.00116 105zM64.00116 117a2.0001 2.0001 0 00-2 2v2a2 2 0 104 0v-2A2.0001 2.0001 0 0064.00116 117zM71.00116 112h-2a2 2 0 100 4h2a2 2 0 000-4zM59.00116 112h-2a2 2 0 100 4h2a2 2 0 000-4zM10.56915 40.89551L9.10693 40.674l-.65387-1.38123a.49514.49514 0 00-.90381 0L6.89539 40.674l-1.46222.2215a.53141.53141 0 00-.2793.896l1.058 1.07513L5.96216 44.3847a.50864.50864 0 00.7312.55377l1.3078-.71674 1.3078.71674a.50864.50864 0 00.7312-.55377l-.24976-1.51807 1.058-1.07513A.53141.53141 0 0010.56915 40.89551zM10.56915 86.89551L9.10693 86.674l-.65387-1.38123a.49514.49514 0 00-.90381 0L6.89539 86.674l-1.46222.2215a.53141.53141 0 00-.2793.896l1.058 1.07513L5.96216 90.3847a.50864.50864 0 00.7312.55377l1.3078-.71674 1.3078.71674a.50864.50864 0 00.7312-.55377l-.24976-1.51807 1.058-1.07513A.53141.53141 0 0010.56915 86.89551zM34.56915 112.89551l-1.46222-.2215-.65387-1.38123a.49514.49514 0 00-.90381 0l-.65387 1.38123-1.46222.2215a.53141.53141 0 00-.2793.896l1.058 1.07513-.24976 1.51807a.50864.50864 0 00.7312.55377l1.3078-.71674 1.3078.71674a.50864.50864 0 00.7312-.55377l-.24976-1.51807 1.058-1.07513A.53141.53141 0 0034.56915 112.89551zM96.56915 112.89551l-1.46222-.2215-.65387-1.38123a.49514.49514 0 00-.90381 0l-.65387 1.38123-1.46222.2215a.53141.53141 0 00-.2793.896l1.058 1.07513-.24976 1.51807a.50864.50864 0 00.7312.55377l1.3078-.71674 1.3078.71674a.50864.50864 0 00.7312-.55377l-.24976-1.51807 1.058-1.07513A.53141.53141 0 0096.56915 112.89551zM122.56915 86.89551l-1.46222-.2215-.65387-1.38123a.49514.49514 0 00-.90381 0l-.65387 1.38123-1.46222.2215a.53141.53141 0 00-.2793.896l1.058 1.07513-.24976 1.51807a.50864.50864 0 00.7312.55377l1.3078-.71674 1.3078.71674a.50864.50864 0 00.7312-.55377l-.24976-1.51807 1.058-1.07513A.53141.53141 0 00122.56915 86.89551zM30.21191 14.86664l-.24976 1.51807a.50864.50864 0 00.7312.55377l1.3078-.71674 1.3078.71674a.50864.50864 0 00.7312-.55377l-.24976-1.51807 1.058-1.07513a.53141.53141 0 00-.2793-.896l-1.46222-.2215-.65387-1.38123a.49514.49514 0 00-.90381 0L30.89539 12.674l-1.46222.2215a.53141.53141 0 00-.2793.896zM122.56915 40.89551l-1.46222-.2215-.65387-1.38123a.49514.49514 0 00-.90381 0l-.65387 1.38123-1.46222.2215a.53141.53141 0 00-.2793.896l1.058 1.07513-.24976 1.51807a.50864.50864 0 00.7312.55377l1.3078-.71674 1.3078.71674a.50864.50864 0 00.7312-.55377l-.24976-1.51807 1.058-1.07513A.53141.53141 0 00122.56915 40.89551zM94.21191 14.86664l-.24976 1.51807a.50864.50864 0 00.7312.55377l1.3078-.71674 1.3078.71674a.50864.50864 0 00.7312-.55377l-.24976-1.51807 1.058-1.07513a.53141.53141 0 00-.2793-.896l-1.46222-.2215-.65387-1.38123a.49514.49514 0 00-.90381 0L94.89539 12.674l-1.46222.2215a.53141.53141 0 00-.2793.896zM55.59509 51.097a24.45193 24.45193 0 013.20569 2.262 32.18663 32.18663 0 012.55048-3.08832 28.51149 28.51149 0 00-2.9469-2.1424zM71.64081 72.07959a28.1014 28.1014 0 00-3.11609-12.873 20.70631 20.70631 0 00-2.54492 4.07587 24.31493 24.31493 0 11-34.93225-12.1853l-2.80933-2.96906A28.31354 28.31354 0 1071.64081 72.07959z" class="color2d4356 svgShape"></path><path fill="#2d4356" d="M72.40735 51.097l-2.8092-2.96887a28.26622 28.26622 0 00-10.132 36.81848 20.65508 20.65508 0 002.54681-4.07465A24.28134 24.28134 0 0172.40735 51.097zM99.76416 48.12805l-2.80951 2.969a24.31 24.31 0 11-27.7674 39.71344 32.18888 32.18888 0 01-2.54431 3.084A28.30693 28.30693 0 1099.76416 48.12805z" class="color2d4356 svgShape"></path><polygon fill="#e8fbfc" points="41.32 37.07 41.32 39.07 36.68 39.07 35.85 40.07 34.19 40.07 36.68 37.07 41.32 37.07" opacity=".4" class="colore8fbfc svgShape"></polygon><polygon fill="#e8fbfc" points="82.68 37.07 82.68 39.07 78.04 39.07 77.21 40.07 75.55 40.07 78.04 37.07 82.68 37.07" opacity=".4" class="colore8fbfc svgShape"></polygon><polygon fill="#e8fbfc" points="52.45 40.07 50.79 40.07 49.96 39.07 45.32 39.07 45.32 37.07 49.96 37.07 52.45 40.07" opacity=".4" class="colore8fbfc svgShape"></polygon><polygon fill="#e8fbfc" points="93.81 40.07 92.15 40.07 91.32 39.07 86.68 39.07 86.68 37.07 91.32 37.07 93.81 40.07" opacity=".4" class="colore8fbfc svgShape"></polygon><path fill="#f9dbd7" d="M13.92993 18.26l-.09985.45a2.47992 2.47992 0 00-1.6001-1.6 2.31293 2.31293 0 00-2.91992 1.71A2.01453 2.01453 0 016.86 20.31a2.33974 2.33974 0 00-1.78992.28 2.265 2.265 0 00-.8501.99 2.31408 2.31408 0 012.64-3.27 2.01453 2.01453 0 002.45007-1.49A2.31293 2.31293 0 0112.23 15.11 2.67206 2.67206 0 0113.92993 18.26zM123.78 21.58a2.265 2.265 0 00-.8501-.99 2.33974 2.33974 0 00-1.78992-.28 2.01453 2.01453 0 01-2.45007-1.49A2.31293 2.31293 0 00115.77 17.11a2.47992 2.47992 0 00-1.6001 1.6l-.09985-.45a2.67206 2.67206 0 011.7-3.15 2.31293 2.31293 0 012.91992 1.71A2.01453 2.01453 0 00121.14 18.31a2.34065 2.34065 0 012.64 3.27z" opacity=".3" class="colorf9dbd7 svgShape"></path><path fill="#a54b3f" d="M123.96 111.82a2.31581 2.31581 0 01-1.03 1.58 2.25565 2.25565 0 01-1.78992.28 2.01313 2.01313 0 00-2.45007 1.5 2.31417 2.31417 0 01-2.91992 1.7 2.6668 2.6668 0 01-1.7-3.15l.09985-.45a2.50174 2.50174 0 001.6001 1.6 2.31417 2.31417 0 002.91992-1.7 2.01313 2.01313 0 012.45007-1.5 2.25565 2.25565 0 001.78992-.28 2.21088 2.21088 0 00.8501-.99A2.35538 2.35538 0 01123.96 111.82zM12.23 116.88a2.31417 2.31417 0 01-2.91992-1.7A2.01313 2.01313 0 006.86 113.68a2.25565 2.25565 0 01-1.78992-.28 2.31581 2.31581 0 01-1.03-1.58A2.35538 2.35538 0 014.22 110.41a2.21088 2.21088 0 00.8501.99 2.25565 2.25565 0 001.78992.28 2.01313 2.01313 0 012.45007 1.5 2.31417 2.31417 0 002.91992 1.7 2.50174 2.50174 0 001.6001-1.6l.09985.45A2.6668 2.6668 0 0112.23 116.88z" opacity=".5" class="colora54b3f svgShape"></path></svg>
                                                </div>
                                                <div class="tracking-content">Match Preferences<span>
                                                    <div className='d-flex justify-content-between'>
                                                        <div class="avatar avatar-xl mt-n7 ms-4 wid-100">
                                                            <img
                                                                // src="https://bootdey.com/img/Content/avatar/avatar1.png"
                                                                src={ITEM?.profilepic}
                                                                alt="Image" class="w-100 rounded-circle border-4 border-white-color-40" />
                                                        </div>
                                                        <div className='av'></div>
                                                        <div class=" wid-100">
                                                            <img
                                                                // src="https://bootdey.com/img/Content/avatar/avatar1.png"
                                                                src={LOGGEDUSERDATA?.profilepic}
                                                                alt="Image" class="w-100 rounded-circle border-4 border-white-color-40" />
                                                        </div>
                                                    </div>
                                                    <p className='m-0'>You matches {partnerrData?.FinalData?.match_pref}/15 of her preferences.</p>
                                                </span></div>
                                            </div>
                                            <div class="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                showModal == true ?
                    <Modal centered show={confirmSubscription} onHide={cancelSubscription}>
                        <Modal.Header closeButton>
                            <Modal.Title>Upgrade Confirmation</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Do you want to Upgrade Now to view full details?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" onClick={handleSubscription}>
                                OK
                            </Button>
                            <Button variant="primary" onClick={cancelSubscription}>
                                Cancel
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    :
                    null
            }
            {/* Horoscope Modal */}
            <HoroscopeModal showModal={showModalHoroscope} handleClose={handleCloseModalHoroscope} />
            {
                isReportModalOpen == true ?
                    <Modal centered show={isReportModalOpen} onHide={handleReportModalClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Send Request</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Do you want to send request?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" onClick={handleReportConfirm}>
                                OK
                            </Button>
                            <Button variant="primary" onClick={handleReportModalClose}>
                                Cancel
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    :
                    null
            }





            {isTest == true ?

                <Modal centered size="xl" show={isTestModalOpen} onHide={handleisTestModalClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>{testData?.testName}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="thank-you-pop">
                            <img src="http://goactionstations.co.uk/wp-content/uploads/2017/03/Green-Round-Tick.png" alt="" />
                            <p>Answer Report: Satisfaction test result is {testData?.testResult} towards life of current visiting profile.</p>


                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={handleisTestModalClose}>
                            OK
                        </Button>
                        <Button variant="primary" onClick={handleisTestModalClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
                :
                null
            }




            {isTesta === true ?
                <Modal centered size="xl" show={isTestModalOpena} onHide={handleisTestModalClosea}>
                    <Modal.Header closeButton>
                        <Modal.Title>{testDataa?.testName}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='d-flex justify-content-center align-items-center'>
                        <img
                            src={testDataa?.path}
                            alt="Test Image"
                            style={{ maxWidth: "100%", maxHeight: "100%", height: "auto" }}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={handleisTestModalClosea}>
                            OK
                        </Button>
                        <Button variant="primary" onClick={handleisTestModalClosea}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
                :
                null
            }



            {isTesthunfif == true ?

                <Modal centered size="lg" show={isTestModalOpen2} onHide={handleisTestModalClose2}>
                    <Modal.Header closeButton>
                        <Modal.Title>{testData?.testName}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="modal-body-1">
                        <div className="modal-body-content">
                            <p>Timer: {testData?.timer}</p>
                            <p>Timestamp: {testData?.timestamp}</p>


                            <h6>Questions & Answers:</h6>
                            {testData?.questionsanswers.map((qa, index) => (
                                <div key={index}>
                                    <p><strong>Question {qa.id}: </strong>{qa.question}</p>
                                    <p><strong>Selected Answer: </strong>{qa.selectedAnswer}</p>
                                    <p><strong>Options: </strong>
                                        {/* {qa.options.join(", ")} */}
                                    </p>
                                    <ul>
                                        {qa?.options.map((option, i) => (
                                            <li key={i}>{i + 1}. {option}</li>
                                        ))}
                                    </ul>
                                </div>
                            ))
                            }
                        </div>


                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={handleisTestModalClose2}>
                            OK
                        </Button>
                        <Button variant="primary" onClick={handleisTestModalClose2}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
                :
                null
            }


        </div >
    )
}
export default MoreProfileDetails



